// 输入json
export const inputJson: any = {
  "CASs": [
    "1333-74-0",//氢气
    "630-08-0",//一氧化碳
    "124-38-9",
    "74-82-8",//甲烷
    "7664-41-7",
    "7732-18-5",
    "67-56-1"
  ],
  "N": 46,
  "device_config": {
    "type": "Distil",
    "P_D": 405300.0,
    "P_B": 437217.37500000006,
    "SPEC": "Total",
    "murphree": 1,
    "T_Drop": 0.0,
    "S1": "B",
    "S2": "QC",
    "V1": 976.0,
    "V2": 0.0,
    "N": 46,
    "eff": [
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ],
      [
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85,
        0.85
      ]
    ]
  },
  "stream_in_info_list": [
    {
      "name": "F1",
      "N_stage": 1,
      "T": 375.95,
      "P": 587685.0,
      "F": 869.0,
      "z": [
        0,
        0,
        0,
        0,
        0,
        0.00625,
        0.99375
      ],
      "phase": "VL"
    },
    {
      "name": "F2",
      "N_stage": 25,
      "T": 377.34999999999997,
      "P": 425565.0,
      "F": 343.4,
      "z": [
        0,
        0,
        0,
        0,
        0,
        0.02494,
        0.97506
      ],
      "phase": "VL"
    },
    {
      "name": "F3",
      "N_stage": 21,
      "T": 393.15,
      "P": 607950.0,
      "F": 669.37,
      "z": [
        0,
        0,
        0.00067,
        0,
        0,
        0.99802,
        0.00131
      ],
      "phase": "VL"
    }
  ],
  "method": "SRK",
  "V_info_list": [
    {
      "N_stage": 10,
      "F": 0.0
    }
  ],
  "L_info_list": [
    {
      "N_stage": 20,
      "F": 0.0
    }
  ],
  "Q_info_list": [
    {
      "N_stage": 6,
      "Q": 0.0
    }
  ]
}

// 输出json
export const outputJson: any = {
  "res": {
    "T": [
      377.5177901701312,
      377.59445672177986,
      377.6521396714124,
      377.70981361816564,
      377.7674886806499,
      377.82517372434586,
      377.8828786549142,
      377.9406145462226,
      377.99839383826446,
      378.0562305071538,
      378.11414034705814,
      378.17214120409784,
      378.23025338153883,
      378.28849997280935,
      378.3469074513833,
      378.4055061618068,
      378.46433119291845,
      378.5234231283104,
      378.5828293663271,
      378.6426053100324,
      378.70306657870714,
      378.7623912397767,
      378.8221017671478,
      378.8822931814942,
      378.94300873286227,
      379.00469104623346,
      379.0672140035617,
      379.13074168157766,
      379.19547747605964,
      379.26167509391354,
      379.3296562578399,
      379.39983282553254,
      379.4727419889537,
      379.5490941025356,
      379.62984948879534,
      379.7163319929176,
      379.8104175682968,
      379.9148398070885,
      380.0337309606435,
      380.1736006880243,
      380.3452641477205,
      380.5679025767813,
      380.8786185534937,
      381.3581508187189,
      382.2151392887914,
      385.552734552383
    ],
    "V": [
      [
        905.7699999995771
      ],
      [
        794725.5707376777
      ],
      [
        794903.661168149
      ],
      [
        795023.5430673788
      ],
      [
        795142.6278677788
      ],
      [
        795260.8507753672
      ],
      [
        795378.1323555332
      ],
      [
        795494.3837489085
      ],
      [
        795609.5057188869
      ],
      [
        795723.3867660261
      ],
      [
        795835.9019340539
      ],
      [
        795946.9101190051
      ],
      [
        796056.2525014924
      ],
      [
        796163.7487003807
      ],
      [
        796269.1946089118
      ],
      [
        796372.3568597812
      ],
      [
        796472.9696801525
      ],
      [
        796570.7268377751
      ],
      [
        796665.2768307681
      ],
      [
        796756.2109806578
      ],
      [
        796842.755649306
      ],
      [
        1541389.1597732939
      ],
      [
        1541563.0850340135
      ],
      [
        1541728.3912677183
      ],
      [
        1541884.1113148204
      ],
      [
        1855353.6211621393
      ],
      [
        1855506.9268823785
      ],
      [
        1855641.602671881
      ],
      [
        1855754.5332056528
      ],
      [
        1855841.8851114034
      ],
      [
        1855898.9293946566
      ],
      [
        1855919.7164556386
      ],
      [
        1855896.7107247438
      ],
      [
        1855820.1599575141
      ],
      [
        1855677.2903767275
      ],
      [
        1855450.9488315035
      ],
      [
        1855117.653934707
      ],
      [
        1854644.25614399
      ],
      [
        1853982.5458305716
      ],
      [
        1853059.4351335415
      ],
      [
        1851758.8220203114
      ],
      [
        1849884.363262723
      ],
      [
        1847076.675502992
      ],
      [
        1842601.5356989442
      ],
      [
        1834700.8793844946
      ],
      [
        1814565.7116607202
      ]
    ],
    "L": [
      [
        794688.8007376783
      ],
      [
        794866.8911681494
      ],
      [
        794986.7730673791
      ],
      [
        795105.857867779
      ],
      [
        795224.0807753676
      ],
      [
        795341.3623555334
      ],
      [
        795457.613748909
      ],
      [
        795572.7357188873
      ],
      [
        795686.6167660266
      ],
      [
        795799.1319340544
      ],
      [
        795910.1401190057
      ],
      [
        796019.4825014931
      ],
      [
        796126.978700381
      ],
      [
        796232.4246089124
      ],
      [
        796335.586859782
      ],
      [
        796436.199680153
      ],
      [
        796533.9568377758
      ],
      [
        796628.5068307688
      ],
      [
        796719.4409806584
      ],
      [
        796805.9856493064
      ],
      [
        1542021.7597732944
      ],
      [
        1542195.685034014
      ],
      [
        1542360.991267719
      ],
      [
        1542516.711314821
      ],
      [
        1856329.6211621396
      ],
      [
        1856482.9268823785
      ],
      [
        1856617.6026718817
      ],
      [
        1856730.5332056535
      ],
      [
        1856817.8851114044
      ],
      [
        1856874.9293946575
      ],
      [
        1856895.7164556396
      ],
      [
        1856872.7107247445
      ],
      [
        1856796.1599575148
      ],
      [
        1856653.2903767275
      ],
      [
        1856426.9488315035
      ],
      [
        1856093.653934707
      ],
      [
        1855620.2561439895
      ],
      [
        1854958.545830571
      ],
      [
        1854035.435133541
      ],
      [
        1852734.822020311
      ],
      [
        1850860.3632627223
      ],
      [
        1848052.6755029913
      ],
      [
        1843577.5356989438
      ],
      [
        1835676.8793844944
      ],
      [
        1815541.7116607204
      ],
      [
        975.9999999999242
      ]
    ],
    "P": [
      [
        405300.0
      ],
      [
        406009.275
      ],
      [
        406718.55000000005
      ],
      [
        407427.82500000007
      ],
      [
        408137.1000000001
      ],
      [
        408846.3750000001
      ],
      [
        409555.65000000014
      ],
      [
        410264.92500000016
      ],
      [
        410974.2000000002
      ],
      [
        411683.4750000002
      ],
      [
        412392.75000000023
      ],
      [
        413102.02500000026
      ],
      [
        413811.3000000003
      ],
      [
        414520.5750000003
      ],
      [
        415229.8500000003
      ],
      [
        415939.12500000035
      ],
      [
        416648.4000000004
      ],
      [
        417357.6750000004
      ],
      [
        418066.9500000004
      ],
      [
        418776.22500000044
      ],
      [
        419485.50000000047
      ],
      [
        420194.7750000005
      ],
      [
        420904.0500000005
      ],
      [
        421613.32500000054
      ],
      [
        422322.60000000056
      ],
      [
        423031.8750000006
      ],
      [
        423741.1500000006
      ],
      [
        424450.4250000006
      ],
      [
        425159.70000000065
      ],
      [
        425868.9750000007
      ],
      [
        426578.2500000007
      ],
      [
        427287.5250000007
      ],
      [
        427996.80000000075
      ],
      [
        428706.07500000077
      ],
      [
        429415.3500000008
      ],
      [
        430124.6250000008
      ],
      [
        430833.90000000084
      ],
      [
        431543.17500000086
      ],
      [
        432252.4500000009
      ],
      [
        432961.7250000009
      ],
      [
        433671.00000000093
      ],
      [
        434380.27500000095
      ],
      [
        435089.550000001
      ],
      [
        435798.825000001
      ],
      [
        436508.100000001
      ],
      [
        437217.37500000006
      ]
    ],
    "X": [
      [
        0.0,
        0.0,
        5.6183428911231326e-08,
        0.0,
        0.0,
        0.0023207506320383317,
        0.9976791931845328
      ],
      [
        0.0,
        0.0,
        6.081597103549283e-11,
        0.0,
        0.0,
        0.0025298526663949587,
        0.997470147272789
      ],
      [
        0.0,
        0.0,
        5.447657428977893e-11,
        0.0,
        0.0,
        0.0027587496697404406,
        0.9972412502757829
      ],
      [
        0.0,
        0.0,
        5.4508772266749414e-11,
        0.0,
        0.0,
        0.0030094104584180354,
        0.9969905894870731
      ],
      [
        0.0,
        0.0,
        5.4540172526791836e-11,
        0.0,
        0.0,
        0.0032840183028100124,
        0.9967159816426499
      ],
      [
        0.0,
        0.0,
        5.4569904511630746e-11,
        0.0,
        0.0,
        0.003584994343898919,
        0.9964150056015312
      ],
      [
        0.0,
        0.0,
        5.459780542088944e-11,
        0.0,
        0.0,
        0.003915032057954922,
        0.9960849678874473
      ],
      [
        0.0,
        0.0,
        5.4623693545971484e-11,
        0.0,
        0.0,
        0.004277126130340907,
        0.9957228738150353
      ],
      [
        0.0,
        0.0,
        5.4647365927430506e-11,
        0.0,
        0.0,
        0.004674620556544037,
        0.9953253793888086
      ],
      [
        0.0,
        0.0,
        5.466859523658231e-11,
        0.0,
        0.0,
        0.00511124515238153,
        0.9948887547929498
      ],
      [
        0.0,
        0.0,
        5.468712634426757e-11,
        0.0,
        0.0,
        0.005591182624405115,
        0.9944088173209077
      ],
      [
        0.0,
        0.0,
        5.470267220030354e-11,
        0.0,
        0.0,
        0.006119116347565369,
        0.9938808835977319
      ],
      [
        0.0,
        0.0,
        5.47149093353897e-11,
        0.0,
        0.0,
        0.006700324303391735,
        0.9932996756418934
      ],
      [
        0.0,
        0.0,
        5.4723471957238246e-11,
        0.0,
        0.0,
        0.00734074389784297,
        0.9926592560474335
      ],
      [
        0.0,
        0.0,
        5.472794469557573e-11,
        0.0,
        0.0,
        0.008047104628504954,
        0.9919528953167671
      ],
      [
        0.0,
        0.0,
        5.472785578295978e-11,
        0.0,
        0.0,
        0.008827019424126854,
        0.9911729805211453
      ],
      [
        0.0,
        0.0,
        5.472266542956592e-11,
        0.0,
        0.0,
        0.009689174223647878,
        0.9903108257216295
      ],
      [
        0.0,
        0.0,
        5.471175625925472e-11,
        0.0,
        0.0,
        0.010643461849480455,
        0.9893565380958077
      ],
      [
        0.0,
        0.0,
        5.4694415961855087e-11,
        0.0,
        0.0,
        0.011701257142789401,
        0.9882987428025162
      ],
      [
        0.0,
        0.0,
        5.466981929364794e-11,
        0.0,
        0.0,
        0.012875621134611978,
        0.9871243788107182
      ],
      [
        0.0,
        0.0,
        6.427144571463984e-11,
        0.0,
        0.0,
        0.01425260777114248,
        0.9857473921645861
      ],
      [
        0.0,
        0.0,
        7.340205440368715e-15,
        0.0,
        0.0,
        0.015313550151122018,
        0.9846864498488705
      ],
      [
        0.0,
        0.0,
        8.37991544319996e-19,
        0.0,
        0.0,
        0.01649815029518051,
        0.9835018497048196
      ],
      [
        0.0,
        0.0,
        9.561806525068844e-23,
        0.0,
        0.0,
        0.017823091872362133,
        0.9821769081276378
      ],
      [
        0.0,
        0.0,
        1.0902656751551397e-26,
        0.0,
        0.0,
        0.01929597560376208,
        0.9807040243962379
      ],
      [
        0.0,
        0.0,
        1.2420321672534683e-30,
        0.0,
        0.0,
        0.021030060361748315,
        0.9789699396382517
      ],
      [
        0.0,
        0.0,
        1.413112351011802e-34,
        0.0,
        0.0,
        0.02298287462217368,
        0.9770171253778263
      ],
      [
        0.0,
        0.0,
        1.605206060038377e-38,
        0.0,
        0.0,
        0.025188302883877838,
        0.9748116971161221
      ],
      [
        0.0,
        0.0,
        1.8198952765054705e-42,
        0.0,
        0.0,
        0.027687235496208183,
        0.9723127645037918
      ],
      [
        0.0,
        0.0,
        2.058413247371039e-46,
        0.0,
        0.0,
        0.03052915676975774,
        0.9694708432302424
      ],
      [
        0.0,
        0.0,
        2.3215094559062785e-50,
        0.0,
        0.0,
        0.033774900267412845,
        0.9662250997325872
      ],
      [
        0.0,
        0.0,
        2.6091406417339195e-54,
        0.0,
        0.0,
        0.03749968965091045,
        0.9625003103490896
      ],
      [
        0.0,
        0.0,
        2.92008108228409e-58,
        0.0,
        0.0,
        0.04179817919286548,
        0.9582018208071345
      ],
      [
        0.0,
        0.0,
        3.251404843407822e-62,
        0.0,
        0.0,
        0.046790640993516736,
        0.9532093590064833
      ],
      [
        0.0,
        0.0,
        3.597804377326644e-66,
        0.0,
        0.0,
        0.052633009491689,
        0.9473669905083111
      ],
      [
        0.0,
        0.0,
        3.9507120565146464e-70,
        0.0,
        0.0,
        0.059530528254466024,
        0.9404694717455341
      ],
      [
        0.0,
        0.0,
        4.297185017268067e-74,
        0.0,
        0.0,
        0.06776008226613567,
        0.9322399177338643
      ],
      [
        0.0,
        0.0,
        4.618531744554587e-78,
        0.0,
        0.0,
        0.07770381225715928,
        0.9222961877428408
      ],
      [
        0.0,
        0.0,
        4.8886765640825125e-82,
        0.0,
        0.0,
        0.08990655260803483,
        0.9100934473919652
      ],
      [
        0.0,
        0.0,
        5.072341392634535e-86,
        0.0,
        0.0,
        0.10517284410309605,
        0.894827155896904
      ],
      [
        0.0,
        0.0,
        5.123259987135015e-90,
        0.0,
        0.0,
        0.12474842742556676,
        0.8752515725744333
      ],
      [
        0.0,
        0.0,
        4.983002285122307e-94,
        0.0,
        0.0,
        0.15067770184371007,
        0.8493222981562899
      ],
      [
        0.0,
        0.0,
        4.5817317599077534e-98,
        0.0,
        0.0,
        0.18659700093234283,
        0.8134029990676571
      ],
      [
        0.0,
        0.0,
        3.844133616793712e-102,
        0.0,
        0.0,
        0.23975902470572272,
        0.7602409752942773
      ],
      [
        0.0,
        0.0,
        2.708784504825438e-106,
        0.0,
        0.0,
        0.3276027068161766,
        0.6723972931838235
      ],
      [
        0.0,
        0.0,
        5.984750153440339e-111,
        0.0,
        0.0,
        0.6963113093870815,
        0.30368869061291837
      ]
    ],
    "Y": [
      [
        0.0,
        0.0,
        0.000495134417749258,
        0.0,
        0.0,
        0.0021241550873367997,
        0.9973807104949141
      ],
      [
        0.0,
        0.0,
        6.204987737055971e-07,
        0.0,
        0.0,
        0.002316230097335284,
        0.9976831494038905
      ],
      [
        0.0,
        0.0,
        5.642523278506518e-07,
        0.0,
        0.0,
        0.0025253235979857134,
        0.9974741121496868
      ],
      [
        0.0,
        0.0,
        5.641609138079962e-07,
        0.0,
        0.0,
        0.0027542105847241853,
        0.9972452252543617
      ],
      [
        0.0,
        0.0,
        5.64076462822427e-07,
        0.0,
        0.0,
        0.003004860876913799,
        0.9969945750466234
      ],
      [
        0.0,
        0.0,
        5.639926468320694e-07,
        0.0,
        0.0,
        0.0032794562972926927,
        0.9967199797100605
      ],
      [
        0.0,
        0.0,
        5.639095221398961e-07,
        0.0,
        0.0,
        0.003580419874093789,
        0.9964190162163836
      ],
      [
        0.0,
        0.0,
        5.638271495149749e-07,
        0.0,
        0.0,
        0.003910442218214712,
        0.9960889939546365
      ],
      [
        0.0,
        0.0,
        5.637455999028769e-07,
        0.0,
        0.0,
        0.004272521472147742,
        0.9957269147822516
      ],
      [
        0.0,
        0.0,
        5.636649498811894e-07,
        0.0,
        0.0,
        0.004669996897992096,
        0.9953294394370585
      ],
      [
        0.0,
        0.0,
        5.635852884458603e-07,
        0.0,
        0.0,
        0.005106603859013572,
        0.9948928325556972
      ],
      [
        0.0,
        0.0,
        5.635067116017941e-07,
        0.0,
        0.0,
        0.005586517830188417,
        0.9944129186631001
      ],
      [
        0.0,
        0.0,
        5.634293344522285e-07,
        0.0,
        0.0,
        0.006114430539781832,
        0.9938850060308844
      ],
      [
        0.0,
        0.0,
        5.633532808276612e-07,
        0.0,
        0.0,
        0.006695609386687182,
        0.9933038272600326
      ],
      [
        0.0,
        0.0,
        5.632786949214256e-07,
        0.0,
        0.0,
        0.007336003891016893,
        0.9926634328302876
      ],
      [
        0.0,
        0.0,
        5.632057389171236e-07,
        0.0,
        0.0,
        0.008042328490200428,
        0.9919571083040603
      ],
      [
        0.0,
        0.0,
        5.631346002470013e-07,
        0.0,
        0.0,
        0.008822213234303643,
        0.9911772236310956
      ],
      [
        0.0,
        0.0,
        5.630654921563218e-07,
        0.0,
        0.0,
        0.009684323063721793,
        0.9903151138707855
      ],
      [
        0.0,
        0.0,
        5.629986622088111e-07,
        0.0,
        0.0,
        0.010638574528275203,
        0.9893608624730631
      ],
      [
        0.0,
        0.0,
        5.629343954862576e-07,
        0.0,
        0.0,
        0.01169631366259229,
        0.988303123403012
      ],
      [
        0.0,
        0.0,
        5.628732371471891e-07,
        0.0,
        0.0,
        0.0128706338552411,
        0.9871288032715223
      ],
      [
        0.0,
        0.0,
        6.429782327045697e-11,
        0.0,
        0.0,
        0.013822773551553794,
        0.986177226384148
      ],
      [
        0.0,
        0.0,
        7.3432175939595e-15,
        0.0,
        0.0,
        0.014884212764225812,
        0.9851157872357676
      ],
      [
        0.0,
        0.0,
        8.383353874753583e-19,
        0.0,
        0.0,
        0.01606933117273062,
        0.9839306688272685
      ],
      [
        0.0,
        0.0,
        9.565729529777605e-23,
        0.0,
        0.0,
        0.017394876366629126,
        0.9826051236333707
      ],
      [
        0.0,
        0.0,
        1.0908392033420399e-26,
        0.0,
        0.0,
        0.018939549954375044,
        0.9810604500456245
      ],
      [
        0.0,
        0.0,
        1.2426854806224287e-30,
        0.0,
        0.0,
        0.02067459776409107,
        0.9793254022359097
      ],
      [
        0.0,
        0.0,
        1.4138555951391008e-34,
        0.0,
        0.0,
        0.022628441999181854,
        0.9773715580008178
      ],
      [
        0.0,
        0.0,
        1.606050292446072e-38,
        0.0,
        0.0,
        0.024835079265946657,
        0.9751649207340534
      ],
      [
        0.0,
        0.0,
        1.820852369215074e-42,
        0.0,
        0.0,
        0.027335313239475696,
        0.9726646867605239
      ],
      [
        0.0,
        0.0,
        2.0594957588319262e-46,
        0.0,
        0.0,
        0.030178775274130924,
        0.969821224725869
      ],
      [
        0.0,
        0.0,
        2.3227303031781463e-50,
        0.0,
        0.0,
        0.03342619161834076,
        0.9665738083816591
      ],
      [
        0.0,
        0.0,
        2.610512784647671e-54,
        0.0,
        0.0,
        0.03715298121446362,
        0.9628470187855366
      ],
      [
        0.0,
        0.0,
        2.9216167912903963e-58,
        0.0,
        0.0,
        0.04145366810212197,
        0.9585463318978777
      ],
      [
        0.0,
        0.0,
        3.2531149622819866e-62,
        0.0,
        0.0,
        0.04644878840327636,
        0.9535512115967236
      ],
      [
        0.0,
        0.0,
        3.5996968851167846e-66,
        0.0,
        0.0,
        0.05229412490979644,
        0.9477058750902039
      ],
      [
        0.0,
        0.0,
        3.952790627288499e-70,
        0.0,
        0.0,
        0.05919528897703182,
        0.940804711022968
      ],
      [
        0.0,
        0.0,
        4.2994463910082086e-74,
        0.0,
        0.0,
        0.06742900394257548,
        0.9325709960574249
      ],
      [
        0.0,
        0.0,
        4.6209631903766865e-78,
        0.0,
        0.0,
        0.07737795434637634,
        0.9226220456536243
      ],
      [
        0.0,
        0.0,
        4.891251399157075e-82,
        0.0,
        0.0,
        0.08958684675237971,
        0.9104131532476197
      ],
      [
        0.0,
        0.0,
        5.075015017261876e-86,
        0.0,
        0.0,
        0.10486110287218776,
        0.8951388971278122
      ],
      [
        0.0,
        0.0,
        5.125963017062073e-90,
        0.0,
        0.0,
        0.12444656733300286,
        0.8755534326669968
      ],
      [
        0.0,
        0.0,
        4.985635545784826e-94,
        0.0,
        0.0,
        0.15038926301040034,
        0.849610736989599
      ],
      [
        0.0,
        0.0,
        4.58415873389311e-98,
        0.0,
        0.0,
        0.1863267959449124,
        0.8136732040550875
      ],
      [
        0.0,
        0.0,
        3.846179059700376e-102,
        0.0,
        0.0,
        0.23951610043169594,
        0.7604838995683045
      ],
      [
        0.0,
        0.0,
        2.7102414460265483e-106,
        0.0,
        0.0,
        0.3274043895862867,
        0.6725956104137136
      ]
    ],
    "K": [
      [
        5432262405652259.0,
        22156843984.98187,
        10366.073968578583,
        7667097.614620136,
        214.03665369841093,
        0.9006825068385417,
        0.9996473272143788
      ],
      [
        5425604973368508.0,
        22160685357.151375,
        10366.10295579356,
        7664274.051861932,
        213.85776080312186,
        0.9009739085677345,
        1.0002505248063527
      ],
      [
        5416603145883611.0,
        22147552113.960434,
        10358.001895582864,
        7656442.773225063,
        213.54549550561174,
        0.9007456538398372,
        1.0002740095575733
      ],
      [
        5407844122920214.0,
        22135447097.619015,
        10350.183896671877,
        7648918.532565474,
        213.23601271808045,
        0.9005013505452986,
        1.0002997702366607
      ],
      [
        5399347919663078.0,
        22124468652.529526,
        10342.674541856035,
        7641728.988229492,
        212.92949702524308,
        0.9002394582157007,
        1.0003281289330483
      ],
      [
        5391136476336060.0,
        22114723937.17989,
        10335.501243139717,
        7634904.24221307,
        212.62613728236911,
        0.8999582068153992,
        1.0003593736031058
      ],
      [
        5383234279850083.0,
        22106332581.20743,
        10328.694608957074,
        7628477.894919492,
        212.3261449899875,
        0.8996556295170278,
        1.000393829343997
      ],
      [
        5375668650753507.0,
        22099428119.673145,
        10322.28880997541,
        7622487.444036596,
        212.0297569183997,
        0.899329542042854,
        1.0004318635240204
      ],
      [
        5368470209064454.0,
        22094160282.796394,
        10316.322163441258,
        7616974.925393183,
        211.73723928075043,
        0.8989775085152111,
        1.000473893299638
      ],
      [
        5361673246578245.0,
        22090696867.06956,
        10310.837609279846,
        7611987.4320159005,
        211.4488911647062,
        0.8985968154586889,
        1.0005203926825061
      ],
      [
        5355316384772323.0,
        22089226973.033005,
        10305.883535328088,
        7607578.019667815,
        211.1650504404115,
        0.8981844243222222,
        1.0005719034518343
      ],
      [
        5349443075501545.0,
        22089963533.431496,
        10301.514418999566,
        7603806.40658885,
        210.88609840896223,
        0.8977369377016037,
        1.0006290452125053
      ],
      [
        5344102536764629.0,
        22093147927.513084,
        10297.792001606102,
        7600740.262671399,
        210.61246823276966,
        0.8972505330222956,
        1.0006925314307735
      ],
      [
        5339350451442825.0,
        22099053522.806763,
        10294.786184783597,
        7598456.187779753,
        210.3446514615583,
        0.8967209171139926,
        1.000763184207329
      ],
      [
        5335250313187519.0,
        22107992329.419285,
        10292.576720973622,
        7597041.568347564,
        210.08321020539887,
        0.8961432328248116,
        1.0008419582206614
      ],
      [
        5331874439810283.0,
        22120320152.7721,
        10291.254513666783,
        7596595.998155173,
        209.82878664370838,
        0.8955119956178907,
        1.0009299631412394
      ],
      [
        5329305938246465.0,
        22136446341.252346,
        10290.924088411093,
        7597233.993403513,
        209.58212087902217,
        0.8948209605939049,
        1.0010285000935062
      ],
      [
        5327640233686392.0,
        22156841581.208702,
        10291.705553495825,
        7599087.138608861,
        209.34406533435802,
        0.8940630304544411,
        1.0011390968325884
      ],
      [
        5326987994346861.0,
        22182052464.939266,
        10293.738283207822,
        7602308.136006931,
        209.11561146461193,
        0.893230063376977,
        1.0012635646190684
      ],
      [
        5327477533619315.0,
        22212713763.835957,
        10297.183994331639,
        7607074.179070579,
        208.89791242676228,
        0.8923127339390186,
        1.0014040554230528
      ],
      [
        5329934284859307.0,
        22252798599.907055,
        10303.05844579945,
        7614506.597366673,
        208.69815325471095,
        0.8912480716020593,
        1.0015717375729614
      ],
      [
        5329423225184474.0,
        22278717502.546314,
        10305.324925985185,
        7617928.827366373,
        208.47375419870772,
        0.8904180046347566,
        1.0017041861952336
      ],
      [
        5330125288643968.0,
        22310450373.81032,
        10309.091585773343,
        7622995.316699899,
        208.26064923801644,
        0.8894981524843142,
        1.0018536577139872
      ],
      [
        5332209897136866.0,
        22348845841.372463,
        10314.578556683953,
        7629942.687928244,
        208.0604957956673,
        0.888477238688978,
        1.0020237495768518
      ],
      [
        5335759658765007.0,
        22394334458.30763,
        10321.894193774147,
        7638888.536749058,
        207.87408230215695,
        0.8873501523154922,
        1.0022164570358298
      ],
      [
        5341879241458832.0,
        22452280875.212612,
        10332.407991187543,
        7651341.351794565,
        207.71115404108596,
        0.8860347874189561,
        1.002448180268215
      ],
      [
        5350185685520233.0,
        22520903042.620758,
        10345.65982204295,
        7666790.594344089,
        207.56849879526038,
        0.8845630511217981,
        1.0027154820212296
      ],
      [
        5361038114775591.0,
        22602002332.84509,
        10362.10488944553,
        7685735.637790565,
        207.4494085504351,
        0.8829112280737789,
        1.0030254734586834
      ],
      [
        5374877682241933.0,
        22697797184.77511,
        10382.30265950868,
        7708790.640203402,
        207.35793975000362,
        0.8810508178161011,
        1.0033871543271045
      ],
      [
        5392249266871110.0,
        22811035834.19673,
        10406.944568822308,
        7736715.219674577,
        207.2991192679622,
        0.8789474934839189,
        1.003812007616236
      ],
      [
        5413837608341605.0,
        22945182566.265327,
        10436.899918453833,
        7770465.311731345,
        207.27928356648022,
        0.8765592653075328,
        1.0043149341309026
      ],
      [
        5440511096516367.0,
        23104646571.233505,
        10473.271697607823,
        7811255.219285298,
        207.30649400941584,
        0.8738345077670548,
        1.0049154953857269
      ],
      [
        5473393015744820.0,
        23295152967.304478,
        10517.487089421089,
        7860658.342995633,
        207.39120756621963,
        0.8707086557389702,
        1.0056398782603173
      ],
      [
        5513956885066536.0,
        23524245147.11252,
        10571.41877606047,
        7920742.717247929,
        207.54717912121654,
        0.8671002442445198,
        1.0065237120612165
      ],
      [
        5564182069570557.0,
        23802105064.018158,
        10637.582443231619,
        7994292.173477701,
        207.79292635515955,
        0.8629044546106847,
        1.0076166359576864
      ],
      [
        5626783603526824.0,
        24142777622.651917,
        10719.428406823685,
        8085134.509370814,
        208.15389436202202,
        0.8579845301978098,
        1.008989397497656
      ],
      [
        5705600420274308.0,
        24566247767.73603,
        10821.833097242905,
        8198696.672967343,
        208.66609210805075,
        0.8521577657116371,
        1.010745945606664
      ],
      [
        5806233434873511.0,
        25101891472.23338,
        10951.905260560074,
        8342921.38505369,
        209.3820416005333,
        0.845174833366088,
        1.013044076997497
      ],
      [
        5937206349507967.0,
        25794805651.9668,
        11120.447819374662,
        8529939.944055308,
        210.38150606170584,
        0.8366847736296592,
        1.0161336233205929
      ],
      [
        6112143174658926.0,
        26717836120.4544,
        11344.688651759383,
        8779226.415904915,
        211.7913784658937,
        0.8261770420647497,
        1.0204301458369955
      ],
      [
        6354290554069558.0,
        27996894519.86734,
        11653.919337671705,
        9124182.50937619,
        213.82628661522665,
        0.8128747250580242,
        1.0266707045519965
      ],
      [
        6706815626274948.0,
        29869657324.107365,
        12102.231391509014,
        9627238.43084388,
        216.8787765742478,
        0.7955287451943059,
        1.0362750954809359
      ],
      [
        7260050810513299.0,
        32844387228.474335,
        12801.826476904696,
        10420156.501379475,
        221.7493412493792,
        0.771970299773444,
        1.0523106512157865
      ],
      [
        8240117072725711.0,
        38232918103.180115,
        14029.50136469836,
        11836764.431145206,
        230.35337572866206,
        0.7379928346402711,
        1.0826297897267843
      ],
      [
        1.0418228533120328e+16,
        50731806735.93657,
        16704.600519603213,
        15038040.301675268,
        248.6893308385523,
        0.6837745317966853,
        1.1540700104382238
      ],
      [
        4.444486314847503e+16,
        300681914148.20544,
        53277.38604923259,
        71017945.96181439,
        438.5089286220253,
        0.47019792249514697,
        2.2147555295735684
      ]
    ],
    "HV": [
      [
        3.194435689579281
      ],
      [
        3.1973691626789464
      ],
      [
        3.199274113552765
      ],
      [
        3.201163782201301
      ],
      [
        3.2030371546707572
      ],
      [
        3.2048929816393352
      ],
      [
        3.206729877822887
      ],
      [
        3.2085463076927025
      ],
      [
        3.2103405641275167
      ],
      [
        3.212110750525148
      ],
      [
        3.213854751876239
      ],
      [
        3.2155702118126257
      ],
      [
        3.2172544932497296
      ],
      [
        3.2189046481622645
      ],
      [
        3.2205173636630753
      ],
      [
        3.2220889210945325
      ],
      [
        3.2236151214753432
      ],
      [
        3.2250912285199327
      ],
      [
        3.226511864379523
      ],
      [
        3.227870927911987
      ],
      [
        3.2291745334133886
      ],
      [
        3.230591007056485
      ],
      [
        3.23194199396216
      ],
      [
        3.233221047846869
      ],
      [
        3.2344170941225445
      ],
      [
        3.2354914515623023
      ],
      [
        3.236459507014189
      ],
      [
        3.2373070953191467
      ],
      [
        3.2380175965516416
      ],
      [
        3.238571493722458
      ],
      [
        3.23894564078815
      ],
      [
        3.2391125349289913
      ],
      [
        3.2390391746965226
      ],
      [
        3.238685856215182
      ],
      [
        3.2380043841595225
      ],
      [
        3.2369361421019267
      ],
      [
        3.2354094598657057
      ],
      [
        3.233337058736646
      ],
      [
        3.2306136228372866
      ],
      [
        3.2271164631810336
      ],
      [
        3.222715297943634
      ],
      [
        3.2173128249897314
      ],
      [
        3.210984265423695
      ],
      [
        3.2044729111809387
      ],
      [
        3.201178324170634
      ],
      [
        3.28307873982895
      ]
    ],
    "HL": [
      [
        -31.647850821692515
      ],
      [
        -31.638138689086915
      ],
      [
        -31.63099554348048
      ],
      [
        -31.62390519319146
      ],
      [
        -31.61687169275313
      ],
      [
        -31.609899870459664
      ],
      [
        -31.602995113517427
      ],
      [
        -31.59616343055795
      ],
      [
        -31.589411551458188
      ],
      [
        -31.582747007850607
      ],
      [
        -31.576178273044896
      ],
      [
        -31.569714869130404
      ],
      [
        -31.563367564449635
      ],
      [
        -31.55714852109726
      ],
      [
        -31.551071576567658
      ],
      [
        -31.545152454480522
      ],
      [
        -31.53940917195704
      ],
      [
        -31.533862352464972
      ],
      [
        -31.528535825746054
      ],
      [
        -31.523457111003957
      ],
      [
        -31.51879951928693
      ],
      [
        -31.513530130694967
      ],
      [
        -31.50852767221286
      ],
      [
        -31.50382486968065
      ],
      [
        -31.49943969790472
      ],
      [
        -31.49560379016176
      ],
      [
        -31.492237244375897
      ],
      [
        -31.489414787498465
      ],
      [
        -31.487227468535856
      ],
      [
        -31.48578672128439
      ],
      [
        -31.485231188064834
      ],
      [
        -31.485734727115158
      ],
      [
        -31.487519469951273
      ],
      [
        -31.49087276733171
      ],
      [
        -31.496174704186217
      ],
      [
        -31.503937536483367
      ],
      [
        -31.51487139911086
      ],
      [
        -31.529988960953144
      ],
      [
        -31.550791329692505
      ],
      [
        -31.579604141351883
      ],
      [
        -31.620249813057313
      ],
      [
        -31.679502633289754
      ],
      [
        -31.77070445950776
      ],
      [
        -31.924528610587345
      ],
      [
        -32.232231986904786
      ],
      [
        -34.69585850057975
      ]
    ]
  },
  "time_cost": 187.79047107696533,
  "M_residual": [
    0.0001796977809452316,
    0.0006601122843148954,
    0.0006417314176799249,
    0.0012360566523821337,
    0.0012459985142246888,
    0.001992212868177856,
    0.0020550874523992957,
    0.0030000719098471906,
    0.003146700625954957,
    0.004348164244184882,
    0.004616316233779172,
    0.006145139744861194,
    0.006580433048435919,
    0.008523408027752755,
    0.009180550268641008,
    0.01164408646011933,
    0.012588634259232456,
    0.015704955432817247,
    669.3700000011995,
    0.03997551743308736,
    0.04265437029607712,
    0.05154649735050043,
    343.4000000005908,
    0.07968067941692425,
    0.08511016837292118,
    0.10218474573775893,
    0.10938473040005192,
    0.13141314098174917,
    0.1409203035873361,
    0.16963178107107524,
    0.1818130821629893,
    0.21979289464070462,
    0.235564611517475,
    0.28687768841336947,
    0.3125079607270891,
    0.38510328166012187,
    0.4178957165859174,
    0.5289545348205138,
    0.4849198552838061,
    0.6613039588555694,
    0.3374387761577964,
    0.6012208178290166
  ],
  "sum_M_residual": 1018.4693844723179,
  "Q_residual": [
    [
      0.0
    ],
    [
      0.0
    ],
    [
      1.3969838619232178e-09
    ],
    [
      9.313225746154785e-10
    ],
    [
      1.3969838619232178e-09
    ],
    [
      6.05359673500061e-09
    ],
    [
      4.656612873077393e-10
    ],
    [
      0.0
    ],
    [
      3.725290298461914e-09
    ],
    [
      1.862645149230957e-09
    ],
    [
      3.259629011154175e-09
    ],
    [
      4.656612873077393e-10
    ],
    [
      4.190951585769653e-09
    ],
    [
      3.259629011154175e-09
    ],
    [
      2.7939677238464355e-09
    ],
    [
      4.6566128730773926e-09
    ],
    [
      1.862645149230957e-09
    ],
    [
      1.3969838619232178e-09
    ],
    [
      25891049.01052562
    ],
    [
      9.313225746154785e-10
    ],
    [
      9.313225746154785e-09
    ],
    [
      2.7939677238464355e-09
    ],
    [
      10894051.083515929
    ],
    [
      9.313225746154785e-10
    ],
    [
      3.725290298461914e-09
    ],
    [
      3.725290298461914e-09
    ],
    [
      9.313225746154785e-09
    ],
    [
      8.381903171539307e-09
    ],
    [
      0.0
    ],
    [
      9.313225746154785e-10
    ],
    [
      5.587935447692871e-09
    ],
    [
      1.862645149230957e-09
    ],
    [
      5.587935447692871e-09
    ],
    [
      4.6566128730773926e-09
    ],
    [
      3.725290298461914e-09
    ],
    [
      8.381903171539307e-09
    ],
    [
      1.1175870895385742e-08
    ],
    [
      3.725290298461914e-09
    ],
    [
      9.313225746154785e-09
    ],
    [
      1.862645149230957e-09
    ],
    [
      1.6763806343078613e-08
    ],
    [
      1.0244548320770264e-08
    ]
  ],
  "sum_Q_residual": [
    36785100.09404169
  ],
  "eq_residual": [
    7.379766262300582e-05,
    8.078359894485545e-05,
    8.846475514721327e-05,
    9.691598164783057e-05,
    0.00010622237300544302,
    0.00011647841848331722,
    0.00012779259817915622,
    0.00014028538001316035,
    0.00015409647888449445,
    0.00016938132646925416,
    0.000186322018799529,
    0.0002051218571307493,
    0.0002260214543519846,
    0.0002492909284238701,
    0.00027525327845879106,
    0.00030427392772174765,
    0.00033679444371038263,
    0.00037331953430054456,
    0.000414465722599502,
    0.0003360490899118308,
    0.0003746253126514058,
    0.0004182768167333809,
    0.00046783912366055874,
    0.0005451785733617438,
    0.0006123693743707997,
    0.0006895916450649041,
    0.0007788125990262906,
    0.0008824349462718227,
    0.0010035741263504823,
    0.0011461461775814606,
    0.0013153365725322719,
    0.0015178884368716034,
    0.0017629823691065055,
    0.002063058449949605,
    0.002435703164222411,
    0.002906014827910315,
    0.003511391539052708,
    0.004309017334802309,
    0.0053909094489086595,
    0.0069125107746334374,
    0.00915623720551477,
    0.01268382292399503,
    0.018772676841190605,
    0.031019364558122098
  ],
  "sum_eq_residual": 0.11473689397069184,
  "summation_residual": [
    5.551115123125783e-16,
    5.551115123125783e-16,
    4.440892098500626e-16,
    0.0,
    0.0,
    4.440892098500626e-16,
    7.771561172376096e-16,
    7.771561172376096e-16,
    5.551115123125783e-16,
    8.881784197001252e-16,
    3.3306690738754696e-16,
    6.661338147750939e-16,
    6.661338147750939e-16,
    6.661338147750939e-16,
    4.440892098500626e-16,
    4.440892098500626e-16,
    6.661338147750939e-16,
    4.440892098500626e-16,
    2.220446049250313e-16,
    4.440892098500626e-16,
    5.551115123125783e-16,
    8.881784197001252e-16,
    9.992007221626409e-16,
    1.1102230246251565e-16,
    4.440892098500626e-16,
    7.771561172376096e-16,
    3.3306690738754696e-16,
    0.0,
    4.440892098500626e-16,
    1.1102230246251565e-16,
    2.220446049250313e-16,
    3.3306690738754696e-16,
    3.3306690738754696e-16,
    0.0,
    2.220446049250313e-16,
    1.1102230246251565e-16,
    4.440892098500626e-16,
    6.661338147750939e-16,
    5.551115123125783e-16,
    0.0,
    3.3306690738754696e-16,
    6.661338147750939e-16,
    1.1102230246251565e-16,
    4.440892098500626e-16
  ],
  "sum_summation_residual": 1.9095836023552692e-14
}

// 定义输出数据映射
export const dataMap: any = {
  P: {
    title: "压力",
    unit: "Pa",
  },
  T: {
    title: "温度",
    unit: "K",
  },
  V: {
    title: "汽相摩尔流量",
    unit: "mol/h",
  },
  L: {
    title: "液相摩尔流量",
    unit: "mol/h",
  },
  HV: {
    title: "汽相焓",
    unit: "J/mol",
  },
  HL: {
    title: "液相焓",
    unit: "J/mol",
  },
  X: {
    title: "液相摩尔分率",
    unit: "",
  },
  Y: {
    title: "汽相摩尔分率",
    unit: "",
  },
  K: {
    title: "相平衡常数",
    unit: "",
  },
};

//物质列表
export const materialProps = [
  {
    "Name_ZH": "氮气",
    "Name_EN": "Nitrogen",
    "Molecular_formula": "N2",
    "cas": "7727-37-9",
    "Alias": "N2",
    "Type": "无机物",
    "MW": 28.01,
  },
  {
    "Name_ZH": "氰化氢",
    "Name_EN": "Hydrocyanic acid",
    "Molecular_formula": "CHN",
    "cas": "74-90-8",
    "Alias": "CHN",
    "Type": "无机物",
    "MW": 27.0253,
  },
  {
    "Name_ZH": "硫化氢",
    "Name_EN": "Hydrogen sulfide",
    "Molecular_formula": "H2S",
    "cas": "7783-06-4",
    "Alias": "H2S",
    "Type": "无机物",
    "MW": 34.081,
  },
  {
    "Name_ZH": "氧硫化碳",
    "Name_EN": "Carbon oxide sulfide",
    "Molecular_formula": "COS",
    "cas": "463-58-1",
    "Alias": "COS",
    "Type": "无机物",
    "MW":60.075,
  },
  {
    "Name_ZH": "氩气",
    "Name_EN": "Argon",
    "Molecular_formula": "Ar",
    "cas": "7440-37-1",
    "Alias": "Ar",
    "Type": "无机物",
    "MW":39.948,
  },
  {
    "_id": "0078d6d1-3700-4f24-995c-0044fd4d5122",
    "cas": "629-59-4",
    "Name_ZH": "十四烷",
    "Name_EN": "N-TETRADECANE",
    "Molecular_formula": "C14H30",
    "Alias": "C14H30",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-59-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-59-4.svg",
    "smiles": "CCCCCCCCCCCCCC",
    "MW": 198.3922,
    "props": {
      "API": 53,
      "CHARGE": null,
      "DCPLS": 68.4979,
      "DGFORM": 66863.196,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -332348.18,
      "DHSFRM": null,
      "DHVLB": 47645.784,
      "FREEZEPT": 279,
      "HCOM": -8733260,
      "HCTYPE": null,
      "HFUS": 45070,
      "MUP": 0,
      "OMEGA": 0.679,
      "PC": 1621.2,
      "RKTZRA": 0.244009,
      "S025E": null,
      "SG": 0.7667,
      "SRKOMG": 0.66172,
      "SRKPC": 1621.21,
      "SRKTC": 692.4,
      "TB": 526.7,
      "TC": 694,
      "TPT": 279.01,
      "VB": 0.33943553,
      "VC": 0.81857925,
      "VLSTD": 0.25936039,
      "ZC": 0.23
    }
  },
  {
    "_id": "08ac1659-98e9-45cb-8737-9745a8229009",
    "cas": "106-97-8",
    "Name_ZH": "丁烷",
    "Name_EN": "N-BUTANE",
    "Molecular_formula": "C4H10",
    "Alias": "C4H10-1",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-97-8.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-97-8.svg",
    "smiles": "C(CC)C",
    "MW": 58.1234,
    "props": {
      "API": 110.6,
      "CHARGE": 0,
      "DCPLS": 26.3718,
      "DGFORM": -17165.88,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -126232.02,
      "DHSFRM": -9.999,
      "DHVLB": 22407.754,
      "FREEZEPT": 134.8,
      "HCOM": -2657320,
      "HCTYPE": null,
      "HFUS": 4661,
      "MUP": 0,
      "OMEGA": 0.193,
      "PC": 3799.6875,
      "RKTZRA": 0.27325065,
      "S025E": 676.3616,
      "SG": 0.5844,
      "SRKOMG": 0.19911,
      "SRKPC": 3796.94,
      "SRKTC": 425.17999,
      "TB": 272.7,
      "TC": 425.2,
      "TPT": 134.86,
      "VB": 0.096575325,
      "VC": 0.2549212,
      "VLSTD": 0.099713183,
      "ZC": 0.274
    }
  },
  {
    "_id": "0b2d61c4-f923-40c4-8faf-b98517f454d1",
    "cas": "112-95-8",
    "Name_ZH": "二十烷",
    "Name_EN": "N-EICOSANE",
    "Molecular_formula": "C20H42",
    "Alias": "C20H42",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-95-8.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-95-8.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCCC",
    "MW": 282.55348,
    "props": {
      "API": 47.1,
      "CHARGE": null,
      "DCPLS": 98.8159,
      "DGFORM": 117397.87,
      "DGSFRM": 69110,
      "DHAQFM": null,
      "DHFORM": -456068.12,
      "DHSFRM": -631300,
      "DHVLB": 57526.632,
      "FREEZEPT": 310,
      "HCOM": -12392000,
      "HCTYPE": null,
      "HFUS": 69870,
      "MUP": 0,
      "OMEGA": 0.907,
      "PC": 1114.575,
      "RKTZRA": 0.22774592,
      "S025E": null,
      "SG": 0.7924,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 617,
      "TC": 767,
      "TPT": 309.58,
      "VB": 0.51503926,
      "VC": 1.19,
      "VLSTD": 0.3574143,
      "ZC": 0.226
    }
  },
  {
    "_id": "13a8aacb-9db8-49fe-b6ca-1ae318f18e4b",
    "cas": "821-95-4",
    "Name_ZH": "十一烯",
    "Name_EN": "1-UNDECENE",
    "Molecular_formula": "C11H22",
    "Alias": "C11H22-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/821-95-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/821-95-4.svg",
    "smiles": "CCCCCCCCCC=C",
    "MW": 154.29568,
    "props": {
      "API": 56.1,
      "CHARGE": null,
      "DCPLS": 386.2791509,
      "DGFORM": 129539.59,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -144863.28,
      "DHSFRM": -9.999,
      "DHVLB": 40905.036,
      "FREEZEPT": 224,
      "HCOM": -6787900,
      "HCTYPE": null,
      "HFUS": 16990,
      "MUP": 1.7064499999999999e-25,
      "OMEGA": 0.518,
      "PC": 1996.1025,
      "RKTZRA": 0.24871675,
      "S025E": null,
      "SG": 0.7544,
      "SRKOMG": 0.51714,
      "SRKPC": 2030.01,
      "SRKTC": 638,
      "TB": 465.8,
      "TC": 637,
      "TPT": 223.99,
      "VB": 0.2536978,
      "VC": 0.53947,
      "VLSTD": 0.20502363,
      "ZC": 0.253
    }
  },
  {
    "_id": "1d18a346-07e9-4286-a57d-790cb1c1d9ca",
    "cas": "6765-39-5",
    "Name_ZH": "十七烯",
    "Name_EN": "1-HEPTADECENE",
    "Molecular_formula": "C17H34",
    "Alias": "C17H34-D1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/6765-39-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/6765-39-5.svg",
    "smiles": "CCCCCCCCCCCCCCCC=C",
    "MW": 238.45696,
    "props": {
      "API": 47.6289,
      "CHARGE": null,
      "DCPLS": 50.6986,
      "DGFORM": 177700,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -268300,
      "DHSFRM": null,
      "DHVLB": 51876.9,
      "FREEZEPT": 284.4,
      "HCOM": -10446000,
      "HCTYPE": null,
      "HFUS": 33400,
      "MUP": 1.3936000000000002e-25,
      "OMEGA": 0.82999,
      "PC": 1334,
      "RKTZRA": 0.24069,
      "S025E": null,
      "SG": 0.78993,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 573.5,
      "TC": 730.5,
      "TPT": 284.4,
      "VB": 0.417688,
      "VC": 0.8755,
      "VLSTD": 0.303050716,
      "ZC": 0.249
    }
  },
  {
    "_id": "1dffe15b-c46f-4f05-98f5-d0b75bc5b3e2",
    "cas": "106-98-9",
    "Name_ZH": "丁烯",
    "Name_EN": "1-BUTENE",
    "Molecular_formula": "C4H8",
    "Alias": "C4H8-1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-98-9.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-98-9.svg",
    "smiles": "CCC=C",
    "MW": 56.10752,
    "props": {
      "API": 103.8,
      "CHARGE": 0,
      "DCPLS": 47.5971,
      "DGFORM": 71343.072,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -125.604,
      "DHSFRM": -9.999,
      "DHVLB": 21930.458,
      "FREEZEPT": 87.8,
      "HCOM": -2540800,
      "HCTYPE": null,
      "HFUS": 3848,
      "MUP": 9.4868328e-26,
      "OMEGA": 0.187,
      "PC": 4022.6025,
      "RKTZRA": 0.27321417,
      "S025E": 545.6816,
      "SG": 0.6013,
      "SRKOMG": 0.18698,
      "SRKPC": 4019.64,
      "SRKTC": 419.59,
      "TB": 266.9,
      "TC": 419.6,
      "TPT": 87.8,
      "VB": 0.089638469,
      "VC": 0.24022497,
      "VLSTD": 0.093580229,
      "ZC": 0.277
    }
  },
  {
    "_id": "204ccb0b-98c9-4cc1-8353-de375df94107",
    "cas": "74-84-0",
    "Name_ZH": "乙烷",
    "Name_EN": "ETHANE",
    "Molecular_formula": "C2H6",
    "Alias": "C2H6",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-84-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-84-0.svg",
    "smiles": "CC",
    "MW": 30.06964,
    "props": {
      "API": 265.5,
      "CHARGE": 0,
      "DCPLS": 7.42509,
      "DGFORM": -32950.1,
      "DGSFRM": null,
      "DHAQFM": -24383.77759,
      "DHFORM": -84740.8,
      "DHSFRM": null,
      "DHVLB": 14716.602,
      "FREEZEPT": 89.9,
      "HCOM": -1428640,
      "HCTYPE": null,
      "HFUS": 2859,
      "MUP": 0,
      "OMEGA": 0.098,
      "PC": 4883.865,
      "RKTZRA": 0.28073756,
      "S025E": 403.5208,
      "SG": 0.3564,
      "SRKOMG": 0.095666,
      "SRKPC": 4880.11,
      "SRKTC": 305.42001,
      "TB": 184.5,
      "TC": 305.4,
      "TPT": 90.352,
      "VB": 0.055061374,
      "VC": 0.14816999,
      "VLSTD": 0.084711587,
      "ZC": 0.285
    }
  },
  {
    "_id": "204f6c44-e952-45fb-94c6-58d0353cd3fb",
    "cas": "108-88-3",
    "Name_ZH": "甲苯",
    "Name_EN": "TOLUENE",
    "Molecular_formula": "C7H8",
    "Alias": "C7H8",
    "Type": "芳香烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/108-88-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/108-88-3.svg",
    "smiles": "CC1=CC=CC=C1",
    "MW": 92.14052,
    "props": {
      "API": 30.8,
      "CHARGE": 0,
      "DCPLS": 45.0268,
      "DGFORM": 122087.09,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 50032.26,
      "DHSFRM": null,
      "DHVLB": 33201.324,
      "FREEZEPT": 178,
      "HCOM": -3734000,
      "HCTYPE": 5,
      "HFUS": 6636,
      "MUP": 1.264911e-25,
      "OMEGA": 0.257,
      "PC": 4113.795,
      "RKTZRA": 0.26498279,
      "S025E": 562.9028,
      "SG": 0.8718,
      "SRKOMG": 0.26506,
      "SRKPC": 4108.59,
      "SRKTC": 591.78998,
      "TB": 383.8,
      "TC": 591.7,
      "TPT": 178.18,
      "VB": 0.11833143,
      "VC": 0.31569876,
      "VLSTD": 0.10591798,
      "ZC": 0.264
    }
  },
  {
    "_id": "24e8504a-0f99-4c59-ab9f-694b3058432a",
    "cas": "629-94-7",
    "Name_ZH": "二十一烷",
    "Name_EN": "N-HENEICOSANE",
    "Molecular_formula": "C21H44",
    "Alias": "C21H44",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-94-7.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-94-7.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCCCC",
    "MW": 296.58036,
    "props": {
      "API": 46.4084,
      "CHARGE": null,
      "DCPLS": 115.14,
      "DGFORM": 123600,
      "DGSFRM": 54750,
      "DHAQFM": null,
      "DHFORM": -477800,
      "DHSFRM": -653450,
      "DHVLB": 57969.9,
      "FREEZEPT": 313.35,
      "HCOM": -12960000,
      "HCTYPE": null,
      "HFUS": 47698,
      "MUP": 0,
      "OMEGA": 0.942004,
      "PC": 1110,
      "RKTZRA": 0.23153,
      "S025E": null,
      "SG": 0.79535,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 629.65,
      "TC": 778,
      "TPT": 313.35,
      "VB": 0.537449,
      "VC": 1.24477,
      "VLSTD": 0.373388208,
      "ZC": 0.223
    }
  },
  {
    "_id": "290b394e-27ad-43d0-9461-a45b4f5fbf38",
    "cas": "124-38-9",
    "Name_ZH": "二氧化碳",
    "Name_EN": "CARBON-DIOXIDE",
    "Molecular_formula": "CO2",
    "Alias": "CO2",
    "Type": "无机物",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/124-38-9.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/124-38-9.svg",
    "smiles": "O=C=O",
    "MW": 44.0098,
    "props": {
      "API": 340,
      "CHARGE": 0,
      "DCPLS": 14.2584,
      "DGFORM": -394400,
      "DGSFRM": null,
      "DHAQFM": -98834.43202,
      "DHFORM": -393520,
      "DHSFRM": null,
      "DHVLB": 17165.88,
      "FREEZEPT": 216.6,
      "HCOM": 0,
      "HCTYPE": null,
      "HFUS": 9019,
      "MUP": 0,
      "OMEGA": 0.225511,
      "PC": 7382.14,
      "RKTZRA": 0.2736149,
      "S025E": 210.8874,
      "SG": 0.3,
      "SRKOMG": 0.22548,
      "SRKPC": 7381.53,
      "SRKTC": 304.19,
      "TB": 185.117,
      "TC": 304.179,
      "TPT": 216.58,
      "VB": 0.035637394,
      "VC": 0.0942835,
      "VLSTD": 0.10067,
      "ZC": 0.275203
    }
  },
  {
    "_id": "2c71d3fa-b4d8-47cb-b3aa-309470594d7d",
    "cas": "74-86-2",
    "Name_ZH": "乙炔",
    "Name_EN": "ACETYLENE",
    "Molecular_formula": "C2H2",
    "Alias": "C2H2",
    "Type": "炔烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-86-2.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-86-2.svg",
    "smiles": "C#C",
    "MW": 26.03788,
    "props": {
      "API": 98.6,
      "CHARGE": 0,
      "DCPLS": null,
      "DGFORM": 209340,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 226882.69,
      "DHSFRM": null,
      "DHVLB": 16956.54,
      "FREEZEPT": 192.4,
      "HCOM": -1255620,
      "HCTYPE": null,
      "HFUS": 3770,
      "MUP": 0,
      "OMEGA": 0.184,
      "PC": 6140.295,
      "RKTZRA": 0.27294748,
      "S025E": 142.1608,
      "SG": 0.615,
      "SRKOMG": 0.18875,
      "SRKPC": 6139.09,
      "SRKTC": 308.32001,
      "TB": 189.2,
      "TC": 308.3,
      "TPT": 192.4,
      "VB": 0.042358304,
      "VC": 0.1131263,
      "VLSTD": 0.0847116,
      "ZC": 0.271
    }
  },
  {
    "_id": "2ea08996-2631-4c33-9c53-3d56cc9abbaa",
    "cas": "142-82-5",
    "Name_ZH": "庚烷",
    "Name_EN": "N-HEPTANE",
    "Molecular_formula": "C7H16",
    "Alias": "C7H16-1",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/142-82-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/142-82-5.svg",
    "smiles": "CCCCCCC",
    "MW": 100.20404,
    "props": {
      "API": 74.1,
      "CHARGE": 0,
      "DCPLS": 53.3171,
      "DGFORM": 7996.788,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -187903.58,
      "DHSFRM": -9.999,
      "DHVLB": 31719.197,
      "FREEZEPT": 182.6,
      "HCOM": -4464730,
      "HCTYPE": null,
      "HFUS": 14050,
      "MUP": 0,
      "OMEGA": 0.351,
      "PC": 2735.775,
      "RKTZRA": 0.2611662,
      "S025E": 1085.6228,
      "SG": 0.6882,
      "SRKOMG": 0.35655,
      "SRKPC": 2735.84,
      "SRKTC": 540.26001,
      "TB": 371.6,
      "TC": 540.2,
      "TPT": 182.57,
      "VB": 0.16373236,
      "VC": 0.43175758,
      "VLSTD": 0.14598819,
      "ZC": 0.263
    }
  },
  {
    "_id": "34130e09-9753-4983-b099-6006cddaab30",
    "cas": "107-21-1",
    "Name_ZH": "乙二醇",
    "Name_EN": "ETHYLENE-GLYCOL",
    "Molecular_formula": "C2H6O2",
    "Alias": "C2H6O2",
    "Type": "醇",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/107-21-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/107-21-1.svg",
    "smiles": "C(CO)O",
    "MW": 62.06844,
    "props": {
      "API": -4.35946,
      "CHARGE": null,
      "DCPLS": 26.6967,
      "DGFORM": -304673.44,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -389581.74,
      "DHSFRM": null,
      "DHVLB": 52544.34,
      "FREEZEPT": 260.2,
      "HCOM": -1059000,
      "HCTYPE": null,
      "HFUS": 9958,
      "MUP": 6.957010699999999e-25,
      "OMEGA": 1.179209,
      "PC": 7700.7,
      "RKTZRA": 0.25365589,
      "S025E": null,
      "SG": 1.11294,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 470.4,
      "TC": 645,
      "TPT": 260.15,
      "VB": 0.068699805,
      "VC": 0.18801967,
      "VLSTD": 0.055882274,
      "ZC": 0.27
    }
  },
  {
    "_id": "3649f14a-61cf-4b09-816d-f7c2b40c65b0",
    "cas": "74-98-6",
    "Name_ZH": "丙烷",
    "Name_EN": "PROPANE",
    "Molecular_formula": "C3H8",
    "Alias": "C3H8",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-98-6.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-98-6.svg",
    "smiles": "CCC",
    "MW": 44.09652,
    "props": {
      "API": 147.2,
      "CHARGE": 0,
      "DCPLS": 31.8871,
      "DGFORM": -23487.948,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -103916.38,
      "DHSFRM": null,
      "DHVLB": 18786.172,
      "FREEZEPT": 85.5,
      "HCOM": -2043120,
      "HCTYPE": null,
      "HFUS": 3524,
      "MUP": 0,
      "OMEGA": 0.152,
      "PC": 4245.5175,
      "RKTZRA": 0.27646774,
      "S025E": 539.9412,
      "SG": 0.5077,
      "SRKOMG": 0.15083,
      "SRKPC": 4249.24,
      "SRKTC": 369.82001,
      "TB": 231.1,
      "TC": 369.8,
      "TPT": 85.47,
      "VB": 0.075783202,
      "VC": 0.20349447,
      "VLSTD": 0.087144215,
      "ZC": 0.281
    }
  },
  {
    "_id": "397b5b00-558f-4f6a-af04-5ae56d3030c6",
    "cas": "108-38-3",
    "Name_ZH": "间二甲苯",
    "Name_EN": "M-XYLENE",
    "Molecular_formula": "C8H10-2",
    "Alias": "C8H10-2",
    "Type": "芳香烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/108-38-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/108-38-3.svg",
    "smiles": "CC1=CC(C)=CC=C1",
    "MW": 106.1674,
    "props": {
      "API": 31.4,
      "CHARGE": null,
      "DCPLS": 39.4026,
      "DGFORM": 118946.99,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 17249.616,
      "DHSFRM": -9.999,
      "DHVLB": 36383.292,
      "FREEZEPT": 225.3,
      "HCOM": -4331800,
      "HCTYPE": 5,
      "HFUS": 11644,
      "MUP": 9.4868328e-26,
      "OMEGA": 0.331,
      "PC": 3546.375,
      "RKTZRA": 0.26028879,
      "S025E": null,
      "SG": 0.8687,
      "SRKOMG": 0.325951,
      "SRKPC": 3541.16,
      "SRKTC": 617.05,
      "TB": 412.3,
      "TC": 617,
      "TPT": 225.3,
      "VB": 0.14101725,
      "VC": 0.37608315,
      "VLSTD": 0.12247943,
      "ZC": 0.26
    }
  },
  {
    "_id": "398b9110-5f77-4184-9c21-2188928d988a",
    "cas": "95-47-6",
    "Name_ZH": "邻二甲苯",
    "Name_EN": "O-XYLENE",
    "Molecular_formula": "C8H10",
    "Alias": "C8H10-1",
    "Type": "芳香烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/95-47-6.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/95-47-6.svg",
    "smiles": "CC1=CC=CC=C1C",
    "MW": 106.1674,
    "props": {
      "API": 28.4,
      "CHARGE": null,
      "DCPLS": 28.6787,
      "DGFORM": 122170.82,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 19008.072,
      "DHSFRM": -9.999,
      "DHVLB": 36843.84,
      "FREEZEPT": 248,
      "HCOM": -4333000,
      "HCTYPE": null,
      "HFUS": 13606,
      "MUP": 1.5811388e-25,
      "OMEGA": 0.314,
      "PC": 3728.76,
      "RKTZRA": 0.26265973,
      "S025E": null,
      "SG": 0.8848,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 417.6,
      "TC": 630.2,
      "TPT": 247.98,
      "VB": 0.13850679,
      "VC": 0.36955556,
      "VLSTD": 0.12026368,
      "ZC": 0.263
    }
  },
  {
    "_id": "4051dd71-5057-4f73-88bd-68f1cb264011",
    "cas": "629-78-7",
    "Name_ZH": "十七烷",
    "Name_EN": "N-HEPTADECANE",
    "Molecular_formula": "C17H36",
    "Alias": "C17H36",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-78-7.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-78-7.svg",
    "smiles": "CCCCCCCCCCCCCCCCC",
    "MW": 240.47284,
    "props": {
      "API": 49.5,
      "CHARGE": null,
      "DCPLS": 52.1369,
      "DGFORM": 92151.468,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -394187.22,
      "DHSFRM": null,
      "DHVLB": 52921.152,
      "FREEZEPT": 295,
      "HCOM": -10568500,
      "HCTYPE": null,
      "HFUS": 40164,
      "MUP": 0,
      "OMEGA": 0.77,
      "PC": 1317.225,
      "RKTZRA": 0.23423578,
      "S025E": null,
      "SG": 0.7817,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 575.2,
      "TC": 733,
      "TPT": 295.134,
      "VB": 0.42506519,
      "VC": 1.0178334,
      "VLSTD": 0.3083695,
      "ZC": 0.22
    }
  },
  {
    "_id": "42e12a64-a851-4fc1-8937-959e87533636",
    "cas": "638-67-5",
    "Name_ZH": "二十三烷",
    "Name_EN": "N-TRICOSANE",
    "Molecular_formula": "C23H48",
    "Alias": "C23H48",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/638-67-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/638-67-5.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCCCCCC",
    "MW": 324.63412,
    "props": {
      "API": 45.2357,
      "CHARGE": null,
      "DCPLS": 121.674,
      "DGFORM": 139800,
      "DGSFRM": 65140,
      "DHAQFM": null,
      "DHFORM": -519200,
      "DHSFRM": -710690,
      "DHVLB": 60438.8,
      "FREEZEPT": 320.65,
      "HCOM": -14170000,
      "HCTYPE": null,
      "HFUS": 53974,
      "MUP": 0,
      "OMEGA": 1.02617,
      "PC": 1020,
      "RKTZRA": 0.22928,
      "S025E": null,
      "SG": 0.80063,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 653.369,
      "TC": 796,
      "TPT": 320.65,
      "VB": 0.599412,
      "VC": 1.35604,
      "VLSTD": 0.405808933,
      "ZC": 0.219
    }
  },
  {
    "_id": "448ce9c7-6e98-48ad-a088-33b6dcd3602e",
    "cas": "13360-61-7",
    "Name_ZH": "十五烯",
    "Name_EN": "1-PENTADECENE",
    "Molecular_formula": "C15H30",
    "Alias": "C15H30-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/13360-61-7.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/13360-61-7.svg",
    "smiles": "CCCCCCCCCCCCCC=C",
    "MW": 210.4032,
    "props": {
      "API": 49.8,
      "CHARGE": null,
      "DCPLS": 54.7681,
      "DGFORM": 163159.6,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -227385.11,
      "DHSFRM": -9.999,
      "DHVLB": 48692.484,
      "FREEZEPT": 269.4,
      "HCOM": -9230000,
      "HCTYPE": null,
      "HFUS": 27900,
      "MUP": 0,
      "OMEGA": 0.682,
      "PC": 1459.08,
      "RKTZRA": 0.2341824,
      "S025E": null,
      "SG": 0.7803,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 541.5,
      "TC": 704,
      "TPT": 269.42,
      "VB": 0.36154608,
      "VC": 0.76349,
      "VLSTD": 0.27025141,
      "ZC": 0.25
    }
  },
  {
    "_id": "50cbd474-49b8-4eca-98b7-35993c169a7d",
    "cas": "74-85-1",
    "Name_ZH": "乙烯",
    "Name_EN": "ETHYLENE",
    "Molecular_formula": "C2H4",
    "Alias": "C2H4",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-85-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-85-1.svg",
    "smiles": "C=C",
    "MW": 28.05376,
    "props": {
      "API": 265.5,
      "CHARGE": 0,
      "DCPLS": null,
      "DGFORM": 68358,
      "DGSFRM": null,
      "DHAQFM": 8684.436801,
      "DHFORM": 52467,
      "DHSFRM": null,
      "DHVLB": 13552.672,
      "FREEZEPT": 104,
      "HCOM": -1323000,
      "HCTYPE": null,
      "HFUS": 3351,
      "MUP": 0,
      "OMEGA": 0.085,
      "PC": 5035.8525,
      "RKTZRA": 0.2812175,
      "S025E": 272.8408,
      "SG": 0.3564,
      "SRKOMG": 0.081963,
      "SRKPC": 5031.79,
      "SRKTC": 282.35999,
      "TB": 169.4,
      "TC": 282.4,
      "TPT": 104,
      "VB": 0.049379563,
      "VC": 0.12867992,
      "VLSTD": 0.0847116,
      "ZC": 0.276
    }
  },
  {
    "_id": "50d1bd7c-2fef-4960-a519-84bbc348008c",
    "cas": "463-49-0",
    "Name_ZH": "丙二烯",
    "Name_EN": "PROPADIENE",
    "Molecular_formula": "C3H4-1",
    "Alias": "C3H4-1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/463-49-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/463-49-0.svg",
    "smiles": "C=C=C",
    "MW": 40.06476,
    "props": {
      "API": 83.9,
      "CHARGE": null,
      "DCPLS": null,
      "DGFORM": 202515.52,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 192257.86,
      "DHSFRM": -9.999,
      "DHVLB": 18631.26,
      "FREEZEPT": 136.9,
      "HCOM": -1856310,
      "HCTYPE": null,
      "HFUS": 4400,
      "MUP": 6.3245552e-26,
      "OMEGA": 0.313,
      "PC": 5471.55,
      "RKTZRA": 0.27460861,
      "S025E": null,
      "SG": 0.657,
      "SRKOMG": 0.15269,
      "SRKPC": 5470,
      "SRKTC": 393.14999,
      "TB": 238.7,
      "TC": 393,
      "TPT": 136.87,
      "VB": 0.060967072,
      "VC": 0.16183091,
      "VLSTD": 0.061153453,
      "ZC": 0.271
    }
  },
  {
    "_id": "57070bdc-50af-478b-97c5-678b141b5e3b",
    "cas": "1599-67-3",
    "Name_ZH": "二十二烯",
    "Name_EN": "1-DOCOSENE",
    "Molecular_formula": "C22H44",
    "Alias": "C22H44-D1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1599-67-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1599-67-3.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCCCC=C",
    "MW": 308.59136,
    "props": {
      "API": 44.3856,
      "CHARGE": null,
      "DCPLS": 38.8802,
      "DGFORM": 219600,
      "DGSFRM": 214000,
      "DHAQFM": null,
      "DHFORM": -371800,
      "DHSFRM": -517800,
      "DHVLB": 62295.9,
      "FREEZEPT": 310.95,
      "HCOM": -13300000,
      "HCTYPE": null,
      "HFUS": 47000,
      "MUP": 1.65905e-25,
      "OMEGA": 0.924399,
      "PC": 1025.18,
      "RKTZRA": 0.23576,
      "S025E": null,
      "SG": 0.8045,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 640.4,
      "TC": 786.054,
      "TPT": 310.95,
      "VB": 0.565281,
      "VC": 1.29724,
      "VLSTD": 0.388128371,
      "ZC": 0.247
    }
  },
  {
    "_id": "5d29466a-731b-40ac-b70e-8372101ddd74",
    "cas": "3452-07-1",
    "Name_ZH": "二十烯",
    "Name_EN": "1-EICOSENE",
    "Molecular_formula": "C20H40",
    "Alias": "C20H40-D1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/3452-07-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/3452-07-1.svg",
    "smiles": "C(CCCCCCCCC=C)CCCCCCCCC",
    "MW": 280.5376,
    "props": {
      "API": 46.1403,
      "CHARGE": null,
      "DCPLS": 48.4779,
      "DGFORM": 202300,
      "DGSFRM": 201100,
      "DHAQFM": null,
      "DHFORM": -330240,
      "DHSFRM": -466200,
      "DHVLB": 56907.1,
      "FREEZEPT": 301.76,
      "HCOM": -12100000,
      "HCTYPE": null,
      "HFUS": 41600,
      "MUP": 1.13763e-25,
      "OMEGA": 0.880599,
      "PC": 1043.18,
      "RKTZRA": 0.23682,
      "S025E": null,
      "SG": 0.79655,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 615.5,
      "TC": 767.739,
      "TPT": 301.76,
      "VB": 0.506738,
      "VC": 1.1365,
      "VLSTD": 0.351180349,
      "ZC": 0.247
    }
  },
  {
    "_id": "630122a4-fdf4-4365-83a5-052fc20166d1",
    "cas": "7664-41-7",
    "Name_ZH": "氨气",
    "Name_EN": "AMMONIA",
    "Molecular_formula": "NH3",
    "Alias": "H3N",
    "Type": "无机物",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/7664-41-7.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/7664-41-7.svg",
    "smiles": "N",
    "MW": 17.03056,
    "props": {
      "API": 340,
      "CHARGE": 0,
      "DCPLS": 25.4003,
      "DGFORM": -16380,
      "DGSFRM": null,
      "DHAQFM": -19176.93704,
      "DHFORM": -45898,
      "DHSFRM": null,
      "DHVLB": 23362.344,
      "FREEZEPT": 195.4,
      "HCOM": -316830,
      "HCTYPE": null,
      "HFUS": 5657,
      "MUP": 4.7434164e-25,
      "OMEGA": 0.25,
      "PC": 11277.473,
      "RKTZRA": 0.24647232,
      "S025E": 291.8245,
      "SG": 0.3,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 239.7,
      "TC": 405.6,
      "TPT": 195.41,
      "VB": 0.024907779,
      "VC": 0.072362166,
      "VLSTD": 0.0535578,
      "ZC": 0.242
    }
  },
  {
    "_id": "6433ce3a-6f70-435f-863c-e4e049d953d7",
    "cas": "115-10-6",
    "Name_ZH": "二甲醚",
    "Name_EN": "DIMETHYL-ETHER",
    "Molecular_formula": "C2H6O",
    "Alias": "C2H6O-1",
    "Type": "醚",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/115-10-6.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/115-10-6.svg",
    "smiles": "COC",
    "MW": 46.06904,
    "props": {
      "API": 83.6737,
      "CHARGE": null,
      "DCPLS": 28.0465,
      "DGFORM": -113001.73,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -184177.33,
      "DHSFRM": null,
      "DHVLB": 21520.152,
      "FREEZEPT": 131.7,
      "HCOM": -1328420,
      "HCTYPE": null,
      "HFUS": 4937,
      "MUP": 4.1109609e-25,
      "OMEGA": 0.192,
      "PC": 5370.225,
      "RKTZRA": 0.27228639,
      "S025E": null,
      "SG": 0.657608,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 248.3,
      "TC": 400,
      "TPT": 131.65,
      "VB": 0.062896955,
      "VC": 0.17772946,
      "VLSTD": 0.068728722,
      "ZC": 0.287
    }
  },
  {
    "_id": "69020680-8231-43df-b015-e702465f958a",
    "cas": "1120-21-4",
    "Name_ZH": "十一烷",
    "Name_EN": "N-UNDECANE",
    "Molecular_formula": "C11H24",
    "Alias": "C11H24",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1120-21-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1120-21-4.svg",
    "smiles": "CCCCCCCCCCC",
    "MW": 156.31156,
    "props": {
      "API": 58.6,
      "CHARGE": 0,
      "DCPLS": 59.9846,
      "DGFORM": 41616.792,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -270467.28,
      "DHSFRM": null,
      "DHVLB": 41533.056,
      "FREEZEPT": 247.6,
      "HCOM": -6903800,
      "HCTYPE": null,
      "HFUS": 22180,
      "MUP": 0,
      "OMEGA": 0.535,
      "PC": 1965.705,
      "RKTZRA": 0.2501229,
      "S025E": null,
      "SG": 0.7443,
      "SRKOMG": 0.53624,
      "SRKPC": 1965.71,
      "SRKTC": 638.76,
      "TB": 469.1,
      "TC": 638.8,
      "TPT": 247.571,
      "VB": 0.26164225,
      "VC": 0.64843706,
      "VLSTD": 0.21051759,
      "ZC": 0.24
    }
  },
  {
    "_id": "699c1d6d-23fc-483c-bb7a-4209a663451c",
    "cas": "100-42-5",
    "Name_ZH": "苯乙烯",
    "Name_EN": "STYRENE",
    "Molecular_formula": "C8H8",
    "Alias": "C8H8",
    "Type": "芳香烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/100-42-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/100-42-5.svg",
    "smiles": "C=CC1=CC=CC=C1",
    "MW": 104.15152,
    "props": {
      "API": 23.8,
      "CHARGE": null,
      "DCPLS": 13.9691854,
      "DGFORM": 213945.48,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 147459.1,
      "DHSFRM": null,
      "DHVLB": 36843.84,
      "FREEZEPT": 242.5,
      "HCOM": -4219000,
      "HCTYPE": null,
      "HFUS": 10950,
      "MUP": 3.1622776e-26,
      "OMEGA": 0.257,
      "PC": 3992.205,
      "RKTZRA": 0.26277682,
      "S025E": null,
      "SG": 0.911,
      "SRKOMG": 0.23574,
      "SRKPC": 4000.01,
      "SRKTC": 648,
      "TB": 418.3,
      "TC": 647,
      "TPT": 242.54,
      "VB": 0.13118065,
      "VC": 0.351999,
      "VLSTD": 0.11457263,
      "ZC": 0.258
    }
  },
  {
    "_id": "6b8458cd-6965-4050-afed-51bdf14a0a42",
    "cas": "124-11-8",
    "Name_ZH": "壬烯",
    "Name_EN": "1-NONENE",
    "Molecular_formula": "C9H18",
    "Alias": "C9H18-3",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/124-11-8.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/124-11-8.svg",
    "smiles": "CCCCCCCC=C",
    "MW": 126.24192,
    "props": {
      "API": 61.4,
      "CHARGE": null,
      "DCPLS": 60.4509,
      "DGFORM": 112750.52,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -103581.43,
      "DHSFRM": -9.999,
      "DHVLB": 36341.424,
      "FREEZEPT": 191.8,
      "HCOM": -5568400,
      "HCTYPE": null,
      "HFUS": 19359,
      "MUP": 0,
      "OMEGA": 0.43,
      "PC": 2340.6075,
      "RKTZRA": 0.25406404,
      "S025E": null,
      "SG": 0.7334,
      "SRKOMG": 0.41712,
      "SRKPC": 2330.01,
      "SRKTC": 593.25,
      "TB": 420,
      "TC": 592,
      "TPT": 191.91,
      "VB": 0.20404886,
      "VC": 0.588791,
      "VLSTD": 0.17256608,
      "ZC": 0.28
    }
  },
  {
    "_id": "6cda6ed5-05e7-45bf-81bf-ae2c6a474035",
    "cas": "629-73-2",
    "Name_ZH": "十六烯",
    "Name_EN": "1-HEXADECENE",
    "Molecular_formula": "C16H32",
    "Alias": "C16H32-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-73-2.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-73-2.svg",
    "smiles": "CCCCCCCCCCCCCCC=C",
    "MW": 224.43008,
    "props": {
      "API": 48.8,
      "CHARGE": null,
      "DCPLS": 28.9476,
      "DGFORM": 171616.93,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -247984.16,
      "DHSFRM": -9.999,
      "DHVLB": 50450.94,
      "FREEZEPT": 277.3,
      "HCOM": -9836300,
      "HCTYPE": null,
      "HFUS": 30190,
      "MUP": 0,
      "OMEGA": 0.721,
      "PC": 1337.49,
      "RKTZRA": 0.22908673,
      "S025E": null,
      "SG": 0.785,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 558,
      "TC": 717,
      "TPT": 277.51,
      "VB": 0.39160845,
      "VC": 0.8195,
      "VLSTD": 0.28656336,
      "ZC": 0.249
    }
  },
  {
    "_id": "6e9d6660-078e-4691-a797-53d9735e514c",
    "cas": "100-41-4",
    "Name_ZH": "乙基苯",
    "Name_EN": "ETHYLBENZENE",
    "Molecular_formula": "C8H10-4",
    "Alias": "C8H10-4",
    "Type": "芳香烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/100-41-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/100-41-4.svg",
    "smiles": "CCC1=CC=CC=C1",
    "MW": 106.1674,
    "props": {
      "API": 30.8,
      "CHARGE": 0,
      "DCPLS": 50.8954,
      "DGFORM": 130670.03,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 29810.016,
      "DHSFRM": -9.999,
      "DHVLB": 35587.8,
      "FREEZEPT": 178.2,
      "HCOM": -4345000,
      "HCTYPE": 5,
      "HFUS": 9173,
      "MUP": 1.264911e-25,
      "OMEGA": 0.301,
      "PC": 3607.17,
      "RKTZRA": 0.262202,
      "S025E": 699.3232,
      "SG": 0.8718,
      "SRKOMG": 0.30578,
      "SRKPC": 3609.41,
      "SRKTC": 617.16998,
      "TB": 409.3,
      "TC": 617.1,
      "TPT": 178.2,
      "VB": 0.13984792,
      "VC": 0.37407157,
      "VLSTD": 0.12206213,
      "ZC": 0.263
    }
  },
  {
    "_id": "70117856-ee5c-431c-a3bb-4165025b336b",
    "cas": "1120-36-1",
    "Name_ZH": "十四烯",
    "Name_EN": "1-TETRADECENE",
    "Molecular_formula": "C14H28",
    "Alias": "C14H28-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1120-36-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1120-36-1.svg",
    "smiles": "CCCCCCCCCCCCC=C",
    "MW": 196.37632,
    "props": {
      "API": 51,
      "CHARGE": null,
      "DCPLS": 59.0045,
      "DGFORM": 154869.73,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -206660.45,
      "DHSFRM": -9.999,
      "DHVLB": 46934.028,
      "FREEZEPT": 260.3,
      "HCOM": -8616890,
      "HCTYPE": null,
      "HFUS": 25470,
      "MUP": 1.61165e-25,
      "OMEGA": 0.644,
      "PC": 1560.405,
      "RKTZRA": 0.23683678,
      "S025E": null,
      "SG": 0.7752,
      "SRKOMG": 0.648167,
      "SRKPC": 1660.01,
      "SRKTC": 692,
      "TB": 524.3,
      "TC": 689,
      "TPT": 260.3,
      "VB": 0.33391282,
      "VC": 0.70749,
      "VLSTD": 0.25390129,
      "ZC": 0.245
    }
  },
  {
    "_id": "7024a30f-6b33-4b68-91d8-70a13d74fd31",
    "cas": "109-66-0",
    "Name_ZH": "戊烷",
    "Name_EN": "N-PENTANE",
    "Molecular_formula": "C5H12",
    "Alias": "C5H12-1",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/109-66-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/109-66-0.svg",
    "smiles": "CCCCC",
    "MW": 72.15028,
    "props": {
      "API": 92.8,
      "CHARGE": 0,
      "DCPLS": 40.3198,
      "DGFORM": -8373.6,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -146538,
      "DHSFRM": -9.999,
      "DHVLB": 25790.688,
      "FREEZEPT": 143.4,
      "HCOM": -3244990,
      "HCTYPE": null,
      "HFUS": 8401.5,
      "MUP": 0,
      "OMEGA": 0.251,
      "PC": 3374.1225,
      "RKTZRA": 0.26891873,
      "S025E": 812.782,
      "SG": 0.631,
      "SRKOMG": 0.25004,
      "SRKPC": 3368.78,
      "SRKTC": 469.64999,
      "TB": 309.2,
      "TC": 469.6,
      "TPT": 143.42,
      "VB": 0.11840335,
      "VC": 0.30316465,
      "VLSTD": 0.11467005,
      "ZC": 0.262
    }
  },
  {
    "_id": "702b169a-b19f-4192-84d3-c9b3c5a1a298",
    "cas": "112-40-3",
    "Name_ZH": "十二烷",
    "Name_EN": "N-DODECANE",
    "Molecular_formula": "C12H26",
    "Alias": "C12H26",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-40-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-40-3.svg",
    "smiles": "CCCCCCCCCCCC",
    "MW": 170.33844,
    "props": {
      "API": 56.5,
      "CHARGE": 0,
      "DCPLS": 62.8955,
      "DGFORM": 50074.128,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -291066.34,
      "DHSFRM": null,
      "DHVLB": 43668.324,
      "FREEZEPT": 263.6,
      "HCOM": -7513600,
      "HCTYPE": null,
      "HFUS": 36840,
      "MUP": 0,
      "OMEGA": 0.562,
      "PC": 1823.85,
      "RKTZRA": 0.24722239,
      "S025E": null,
      "SG": 0.7526,
      "SRKOMG": 0.57344,
      "SRKPC": 1823.86,
      "SRKTC": 658.2,
      "TB": 489.5,
      "TC": 658.3,
      "TPT": 263.568,
      "VB": 0.2877016,
      "VC": 0.72020478,
      "VLSTD": 0.22686909,
      "ZC": 0.24
    }
  },
  {
    "_id": "76ef1bfd-e977-4b06-aa88-ba0c244bc286",
    "cas": "111-84-2",
    "Name_ZH": "壬烷",
    "Name_EN": "N-NONANE",
    "Molecular_formula": "C9H20",
    "Alias": "C9H20-1",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/111-84-2.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/111-84-2.svg",
    "smiles": "CCCCCCCCC",
    "MW": 128.2578,
    "props": {
      "API": 64.6,
      "CHARGE": 0,
      "DCPLS": 54.753,
      "DGFORM": 24827.724,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -229185.43,
      "DHSFRM": -9.999,
      "DHVLB": 36940.136,
      "FREEZEPT": 219.7,
      "HCOM": -5684550,
      "HCTYPE": null,
      "HFUS": 15470,
      "MUP": 0,
      "OMEGA": 0.444,
      "PC": 2310.21,
      "RKTZRA": 0.25625141,
      "S025E": null,
      "SG": 0.7217,
      "SRKOMG": 0.43804,
      "SRKPC": 2305.61,
      "SRKTC": 595.65,
      "TB": 424,
      "TC": 594.6,
      "TPT": 219.66,
      "VB": 0.21141721,
      "VC": 0.55636117,
      "VLSTD": 0.17816973,
      "ZC": 0.26
    }
  },
  {
    "_id": "80676ba1-9f28-4f2b-89e7-ee40742c69ff",
    "cas": "7446-09-5",
    "Name_ZH": "二氧化硫",
    "Name_EN": "SULFUR-DIOXIDE",
    "Molecular_formula": "SO2",
    "Alias": "O2S",
    "Type": "无机物",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/7446-09-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/7446-09-5.svg",
    "smiles": "O=S=O",
    "MW": 64.0648,
    "props": {
      "API": 340,
      "CHARGE": 0,
      "DCPLS": 18.251,
      "DGFORM": -300160,
      "DGSFRM": null,
      "DHAQFM": -77142.44769,
      "DHFORM": -296840,
      "DHSFRM": null,
      "DHVLB": 24932.394,
      "FREEZEPT": 197.7,
      "HCOM": 0,
      "HCTYPE": null,
      "HFUS": 7401,
      "MUP": 5.0596442e-25,
      "OMEGA": 0.251,
      "PC": 7883.085,
      "RKTZRA": 0.26626884,
      "S025E": 237.203,
      "SG": 0.3,
      "SRKOMG": 0.245106,
      "SRKPC": 7884.13,
      "SRKTC": 430.75,
      "TB": 263,
      "TC": 430.8,
      "TPT": 197.67,
      "VB": 0.044029553,
      "VC": 0.12176551,
      "VLSTD": 0.0535578,
      "ZC": 0.268
    }
  },
  {
    "_id": "81e7b78a-1dd4-4773-99e5-84fbdcbc8877",
    "cas": "593-45-3",
    "Name_ZH": "十八烷",
    "Name_EN": "N-OCTADECANE",
    "Molecular_formula": "C18H38",
    "Alias": "C18H38",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/593-45-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/593-45-3.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCC",
    "MW": 254.49972,
    "props": {
      "API": 48.6,
      "CHARGE": null,
      "DCPLS": 75.9279,
      "DGFORM": 100566.94,
      "DGSFRM": 63460,
      "DHAQFM": null,
      "DHFORM": -414828.14,
      "DHSFRM": -567140,
      "DHVLB": 54512.136,
      "FREEZEPT": 301.3,
      "HCOM": -11172600,
      "HCTYPE": null,
      "HFUS": 61706,
      "MUP": 0,
      "OMEGA": 0.79,
      "PC": 1205.7675,
      "RKTZRA": 0.22812384,
      "S025E": null,
      "SG": 0.7856,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 589.5,
      "TC": 745,
      "TPT": 301.31,
      "VB": 0.45567774,
      "VC": 1.07,
      "VLSTD": 0.3247479,
      "ZC": 0.232
    }
  },
  {
    "_id": "8379db35-5156-4f60-bf09-35e78d904d43",
    "cas": "110-54-3",
    "Name_ZH": "己烷",
    "Name_EN": "N-HEXANE",
    "Molecular_formula": "C6H14",
    "Alias": "C6H14-1",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/110-54-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/110-54-3.svg",
    "smiles": "CCCCCC",
    "MW": 86.17716,
    "props": {
      "API": 81.6,
      "CHARGE": 0,
      "DCPLS": 43.5379,
      "DGFORM": -251.208,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -167304.53,
      "DHSFRM": -9.999,
      "DHVLB": 28872.173,
      "FREEZEPT": 177.8,
      "HCOM": -3855100,
      "HCTYPE": null,
      "HFUS": 13080,
      "MUP": 0,
      "OMEGA": 0.296,
      "PC": 2968.8225,
      "RKTZRA": 0.26214133,
      "S025E": 949.2024,
      "SG": 0.664,
      "SRKOMG": 0.31099,
      "SRKPC": 3012.32,
      "SRKTC": 507.42999,
      "TB": 341.9,
      "TC": 507.4,
      "TPT": 177.83,
      "VB": 0.1409034,
      "VC": 0.36944483,
      "VLSTD": 0.13013829,
      "ZC": 0.26
    }
  },
  {
    "_id": "855b1299-d7b5-466d-8ef0-450fef84fd8f",
    "cas": "629-97-0",
    "Name_ZH": "二十二烷",
    "Name_EN": "N-DOCOSANE",
    "Molecular_formula": "C22H46",
    "Alias": "C22H46",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-97-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-97-0.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCCCCC",
    "MW": 310.60724,
    "props": {
      "API": 45.7935,
      "CHARGE": null,
      "DCPLS": 123.823,
      "DGFORM": 131500,
      "DGSFRM": 58600,
      "DHAQFM": null,
      "DHFORM": -498500,
      "DHSFRM": -682070,
      "DHVLB": 59304,
      "FREEZEPT": 317.15,
      "HCOM": -13570000,
      "HCTYPE": null,
      "HFUS": 48953,
      "MUP": 0,
      "OMEGA": 0.97219,
      "PC": 1060,
      "RKTZRA": 0.22995,
      "S025E": null,
      "SG": 0.79811,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 641.76,
      "TC": 787,
      "TPT": 317.15,
      "VB": 0.56791,
      "VC": 1.30113,
      "VLSTD": 0.38981766,
      "ZC": 0.221
    }
  },
  {
    "_id": "8bce6648-6e03-4197-9426-c6b0d7df1b0f",
    "cas": "1599-68-4",
    "Name_ZH": "二十一烯",
    "Name_EN": "1-HENEICOSENE",
    "Molecular_formula": "C21H42",
    "Alias": "C21H42-N2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1599-68-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1599-68-4.svg",
    "smiles": "C(CCCCCCCCCC)CCCCCCCCC=C",
    "MW": 294.56448,
    "props": {
      "API": null,
      "CHARGE": null,
      "DCPLS": null,
      "DGFORM": 211461,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -350940,
      "DHSFRM": null,
      "DHVLB": null,
      "FREEZEPT": 308.6,
      "HCOM": null,
      "HCTYPE": null,
      "HFUS": null,
      "MUP": null,
      "OMEGA": 0.904797,
      "PC": 1077.63,
      "RKTZRA": null,
      "S025E": null,
      "SG": 0.950425,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 628.2,
      "TC": 776.697,
      "TPT": 308.6,
      "VB": null,
      "VC": 1.24047,
      "VLSTD": null,
      "ZC": 0.198405
    }
  },
  {
    "_id": "8d6bc090-f842-4567-a315-0f9f3dec0191",
    "cas": "110-65-6",
    "Name_ZH": "丁炔二醇",
    "Name_EN": "2-BUTYNE-1,4-DIOL",
    "Molecular_formula": "C4H6O2",
    "Alias": "C4H6O2-D1",
    "Type": "醇",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/110-65-6.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/110-65-6.svg",
    "smiles": "OCC#CCO",
    "MW": 86.09044,
    "props": {
      "API": -10.6566,
      "CHARGE": null,
      "DCPLS": 24.1678,
      "DGFORM": -39970,
      "DGSFRM": -74910,
      "DHAQFM": null,
      "DHFORM": -155000,
      "DHSFRM": -227000,
      "DHVLB": 68158.4,
      "FREEZEPT": 331,
      "HCOM": -2049990,
      "HCTYPE": null,
      "HFUS": 17100,
      "MUP": 8.3167586e-25,
      "OMEGA": 1.13426,
      "PC": 5860,
      "RKTZRA": 0.24788,
      "S025E": null,
      "SG": 1.17094,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 511.148,
      "TC": 695,
      "TPT": 331,
      "VB": 0.0948708,
      "VC": 0.256,
      "VLSTD": 0.083670645,
      "ZC": 0.26
    }
  },
  {
    "_id": "96592c96-277c-41ed-875d-19766dc25ada",
    "cas": "64-19-7",
    "Name_ZH": "醋酸",
    "Name_EN": "ACETIC-ACID",
    "Molecular_formula": "C2H4O2",
    "Alias": "C2H4O2-1",
    "Type": "酸",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/64-19-7.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/64-19-7.svg",
    "smiles": "CC(O)=O",
    "MW": 60.05256,
    "props": {
      "API": 2.6,
      "CHARGE": 0,
      "DCPLS": 27.2997,
      "DGFORM": -376938,
      "DGSFRM": null,
      "DHAQFM": -116099.89,
      "DHFORM": -435134,
      "DHSFRM": null,
      "DHVLB": 23697.288,
      "FREEZEPT": 289.8,
      "HCOM": -815700,
      "HCTYPE": null,
      "HFUS": 11730,
      "MUP": 4.1109609e-25,
      "OMEGA": 0.454,
      "PC": 5785.6575,
      "RKTZRA": 0.22716834,
      "S025E": 477.9878,
      "SG": 1.0553,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 391.1,
      "TC": 594.4,
      "TPT": 289.81,
      "VB": 0.065186878,
      "VC": 0.17083077,
      "VLSTD": 0.057110509,
      "ZC": 0.2
    }
  },
  {
    "_id": "9c0fc204-a766-4c24-8f7d-d8ada0456288",
    "cas": "112-88-9",
    "Name_ZH": "十八烯",
    "Name_EN": "1-OCTADECENE",
    "Molecular_formula": "C18H36",
    "Alias": "C18H36-1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-88-9.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-88-9.svg",
    "smiles": "C(CCCCCCCC=C)CCCCCCCC",
    "MW": 252.48384,
    "props": {
      "API": 40.7,
      "CHARGE": null,
      "DCPLS": 51.5149,
      "DGFORM": 188447.87,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -289224.14,
      "DHSFRM": -9.999,
      "DHVLB": 54302.796,
      "FREEZEPT": 290.8,
      "HCOM": -11055700,
      "HCTYPE": null,
      "HFUS": 36100,
      "MUP": 1.16608e-25,
      "OMEGA": 0.807,
      "PC": 1134.84,
      "RKTZRA": 0.21957864,
      "S025E": null,
      "SG": 0.8217,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 588,
      "TC": 739,
      "TPT": 290.76,
      "VB": 0.4537826,
      "VC": 0.9315,
      "VLSTD": 0.30795598,
      "ZC": 0.248
    }
  },
  {
    "_id": "9db8cc3d-1456-4e6a-a966-3d13d106e114",
    "cas": "629-50-5",
    "Name_ZH": "十三烷",
    "Name_EN": "N-TRIDECANE",
    "Molecular_formula": "C13H28",
    "Alias": "C13H28",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-50-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-50-5.svg",
    "smiles": "CCCCCCCCCCCCC",
    "MW": 184.36532,
    "props": {
      "API": 54.6,
      "CHARGE": null,
      "DCPLS": 26.8909,
      "DGFORM": 58489.596,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -311707.26,
      "DHSFRM": null,
      "DHVLB": 45677.988,
      "FREEZEPT": 267.8,
      "HCOM": -8123490,
      "HCTYPE": null,
      "HFUS": 28500,
      "MUP": 0,
      "OMEGA": 0.623,
      "PC": 1722.525,
      "RKTZRA": 0.24616313,
      "S025E": null,
      "SG": 0.7601,
      "SRKOMG": 0.618625,
      "SRKPC": 1722.54,
      "SRKTC": 675.8,
      "TB": 508.6,
      "TC": 675.8,
      "TPT": 267.76,
      "VB": 0.31349172,
      "VC": 0.78284164,
      "VLSTD": 0.24310508,
      "ZC": 0.24
    }
  },
  {
    "_id": "a544afff-6dd1-449b-8248-0e05bd58ed35",
    "cas": "872-05-9",
    "Name_ZH": "癸烯",
    "Name_EN": "1-DECENE",
    "Molecular_formula": "C10H20",
    "Alias": "C10H20-5",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/872-05-9.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/872-05-9.svg",
    "smiles": "C(CCCC=C)CCCC",
    "MW": 140.2688,
    "props": {
      "API": 58.4,
      "CHARGE": null,
      "DCPLS": 319.4092091,
      "DGFORM": 121124.12,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -124222.36,
      "DHSFRM": null,
      "DHVLB": 38686.032,
      "FREEZEPT": 206.9,
      "HCOM": -6178200,
      "HCTYPE": null,
      "HFUS": 13810,
      "MUP": 0,
      "OMEGA": 0.491,
      "PC": 2208.885,
      "RKTZRA": 0.25480188,
      "S025E": null,
      "SG": 0.745,
      "SRKOMG": 0.4645,
      "SRKPC": 2168.36,
      "SRKTC": 617.05,
      "TB": 443.7,
      "TC": 615,
      "TPT": 206.9,
      "VB": 0.22834191,
      "VC": 0.64814185,
      "VLSTD": 0.18873322,
      "ZC": 0.28
    }
  },
  {
    "_id": "a63c7a23-b5bd-4078-9c03-5c87eb059ab4",
    "cas": "106-42-3",
    "Name_ZH": "对二甲苯",
    "Name_EN": "P-XYLENE",
    "Molecular_formula": "C8H10-3",
    "Alias": "C8H10-3",
    "Type": "芳香烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-42-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-42-3.svg",
    "smiles": "CC1=CC=C(C)C=C1",
    "MW": 106.1674,
    "props": {
      "API": 31.9,
      "CHARGE": 0,
      "DCPLS": 22.6355,
      "DGFORM": 121207.86,
      "DGSFRM": 109309,
      "DHAQFM": null,
      "DHFORM": 17961.372,
      "DHSFRM": -9.999,
      "DHVLB": 36006.48,
      "FREEZEPT": 286.4,
      "HCOM": -4333000,
      "HCTYPE": null,
      "HFUS": 17110,
      "MUP": 3.1622776e-26,
      "OMEGA": 0.324,
      "PC": 3515.9775,
      "RKTZRA": 0.25969142,
      "S025E": null,
      "SG": 0.8657,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 411.5,
      "TC": 616.2,
      "TPT": 286.402,
      "VB": 0.141437,
      "VC": 0.37884275,
      "VLSTD": 0.12291098,
      "ZC": 0.26
    }
  },
  {
    "_id": "aff0711b-ce54-4fe8-90b5-27c528f69617",
    "cas": "592-41-6",
    "Name_ZH": "己烯",
    "Name_EN": "1-HEXENE",
    "Molecular_formula": "C6H12",
    "Alias": "C6H12-3",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/592-41-6.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/592-41-6.svg",
    "smiles": "C(CC=C)CC",
    "MW": 84.16128,
    "props": {
      "API": 77.2,
      "CHARGE": 0,
      "DCPLS": 51.5736,
      "DGFORM": 87504.12,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -41700.528,
      "DHSFRM": null,
      "DHVLB": 28302.768,
      "FREEZEPT": 133.3,
      "HCOM": -3739400,
      "HCTYPE": 3,
      "HFUS": 9347,
      "MUP": 1.264911e-25,
      "OMEGA": 0.285,
      "PC": 3171.4725,
      "RKTZRA": 0.26589357,
      "S025E": 818.5224,
      "SG": 0.678,
      "SRKOMG": 0.28117,
      "SRKPC": 3140,
      "SRKTC": 504.03,
      "TB": 336.6,
      "TC": 504,
      "TPT": 133.39,
      "VB": 0.13360061,
      "VC": 0.34352073,
      "VLSTD": 0.12447434,
      "ZC": 0.26
    }
  },
  {
    "_id": "b387f86e-b5f0-4431-bea5-cf23da57cd59",
    "cas": "124-18-5",
    "Name_ZH": "癸烷",
    "Name_EN": "N-DECANE",
    "Molecular_formula": "C10H22",
    "Alias": "C10H22-1",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/124-18-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/124-18-5.svg",
    "smiles": "CCCCCCCCCC",
    "MW": 142.28468,
    "props": {
      "API": 61.2,
      "CHARGE": 0,
      "DCPLS": 52.3723,
      "DGFORM": 33243.192,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -249826.36,
      "DHSFRM": -9.999,
      "DHVLB": 39305.678,
      "FREEZEPT": 243.5,
      "HCOM": -6294200,
      "HCTYPE": null,
      "HFUS": 28710,
      "MUP": 0,
      "OMEGA": 0.49,
      "PC": 2107.56,
      "RKTZRA": 0.2519382,
      "S025E": null,
      "SG": 0.7342,
      "SRKOMG": 0.47627,
      "SRKPC": 2122.91,
      "SRKTC": 618.45,
      "TB": 447.3,
      "TC": 617.6,
      "TPT": 243.51,
      "VB": 0.23642302,
      "VC": 0.60177524,
      "VLSTD": 0.19428313,
      "ZC": 0.247
    }
  },
  {
    "_id": "b3edf36c-6dd0-4658-90ca-d33e639ab994",
    "cas": "74-82-8",
    "Name_ZH": "甲烷",
    "Name_EN": "METHANE",
    "Molecular_formula": "CH4",
    "Alias": "CH4",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-82-8.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/74-82-8.svg",
    "smiles": "C",
    "MW": 16.04276,
    "props": {
      "API": 340,
      "CHARGE": 0,
      "DCPLS": 9.757,
      "DGFORM": -50815,
      "DGSFRM": null,
      "DHAQFM": -21266.83864,
      "DHFORM": -74873,
      "DHSFRM": null,
      "DHVLB": 8185.194,
      "FREEZEPT": 90.7,
      "HCOM": -802620,
      "HCTYPE": null,
      "HFUS": 941.4,
      "MUP": 0,
      "OMEGA": 0.0114328,
      "PC": 4606.47,
      "RKTZRA": 0.28819729,
      "S025E": 267.1004,
      "SG": 0.3,
      "SRKOMG": 0.0047318,
      "SRKPC": 4604.32,
      "SRKTC": 190.58,
      "TB": 111.655,
      "TC": 190.563,
      "TPT": 90.694,
      "VB": 0.037748235,
      "VC": 0.0989612,
      "VLSTD": 0.0535578,
      "ZC": 0.287713
    }
  },
  {
    "_id": "b5497acf-880a-44eb-9b89-35a9a035d97b",
    "cas": "67-56-1",
    "Name_ZH": "甲醇",
    "Name_EN": "METHANOL",
    "Molecular_formula": "CH3OH",
    "Alias": "CH4O",
    "Type": "醇",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/67-56-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/67-56-1.svg",
    "smiles": "CO",
    "MW": 32.04216,
    "props": {
      "API": 46.2,
      "CHARGE": 0,
      "DCPLS": 6.69265,
      "DGFORM": -162615,
      "DGSFRM": null,
      "DHAQFM": -58739.6102,
      "DHFORM": -201301,
      "DHSFRM": null,
      "DHVLB": 35277.977,
      "FREEZEPT": 175.5,
      "HCOM": -638200,
      "HCTYPE": null,
      "HFUS": 3215,
      "MUP": 5.3758719e-25,
      "OMEGA": 0.559,
      "PC": 8095.8675,
      "RKTZRA": 0.237683,
      "S025E": 369.6739,
      "SG": 0.7962,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 337.8,
      "TC": 512.6,
      "TPT": 175.47,
      "VB": 0.043496416,
      "VC": 0.11791614,
      "VLSTD": 0.04033458,
      "ZC": 0.224
    }
  },
  {
    "_id": "b55f8352-54ee-4bf8-adb2-9d0085535e2b",
    "cas": "75-01-4",
    "Name_ZH": "氯乙烯",
    "Name_EN": "VINYL-CHLORIDE",
    "Molecular_formula": "C2H3CL",
    "Alias": "C2H3CL",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/75-01-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/75-01-4.svg",
    "smiles": "ClC=C",
    "MW": 62.49852,
    "props": {
      "API": 24.8319,
      "CHARGE": null,
      "DCPLS": null,
      "DGFORM": 51539.508,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 35169.12,
      "DHSFRM": null,
      "DHVLB": 20640.924,
      "FREEZEPT": 119.4,
      "HCOM": -1178000,
      "HCTYPE": null,
      "HFUS": 4744,
      "MUP": 4.7434164e-25,
      "OMEGA": 0.122,
      "PC": 5603.2725,
      "RKTZRA": 0.27370008,
      "S025E": null,
      "SG": 0.905126,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 259.8,
      "TC": 429.7,
      "TPT": 119.36,
      "VB": 0.064584614,
      "VC": 0.16895829,
      "VLSTD": 0.067980989,
      "ZC": 0.265
    }
  },
  {
    "_id": "b6910e08-fa7d-416a-b703-3166cef4d350",
    "cas": "71-43-2",
    "Name_ZH": "苯",
    "Name_EN": "BENZENE",
    "Molecular_formula": "C6H6",
    "Alias": "C6H6",
    "Type": "芳香烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/71-43-2.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/71-43-2.svg",
    "smiles": "C1=CC=CC=C1",
    "MW": 78.11364,
    "props": {
      "API": 28.5,
      "CHARGE": 0,
      "DCPLS": 1.33733,
      "DGFORM": 129748.93,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 82982.376,
      "DHSFRM": null,
      "DHVLB": 30781.354,
      "FREEZEPT": 278.7,
      "HCOM": -3136000,
      "HCTYPE": 5,
      "HFUS": 9866,
      "MUP": 0,
      "OMEGA": 0.212,
      "PC": 4893.9975,
      "RKTZRA": 0.2690165,
      "S025E": 426.4824,
      "SG": 0.8844,
      "SRKOMG": 0.21075,
      "SRKPC": 4898.04,
      "SRKTC": 562.15997,
      "TB": 353.3,
      "TC": 562.1,
      "TPT": 278.68,
      "VB": 0.095508434,
      "VC": 0.25877907,
      "VLSTD": 0.088509105,
      "ZC": 0.271
    }
  },
  {
    "_id": "be9cdb7d-c92d-4eab-b63d-b30242e2bcb2",
    "cas": "115-07-1",
    "Name_ZH": "丙烯",
    "Name_EN": "PROPYLENE",
    "Molecular_formula": "C3H6",
    "Alias": "C3H6-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/115-07-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/115-07-1.svg",
    "smiles": "CC=C",
    "MW": 42.08064,
    "props": {
      "API": 139.6,
      "CHARGE": 0,
      "DCPLS": 29.3019,
      "DGFORM": 62760.132,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 20431.584,
      "DHSFRM": null,
      "DHVLB": 18421.92,
      "FREEZEPT": 87.9,
      "HCOM": -1925700,
      "HCTYPE": null,
      "HFUS": 2936,
      "MUP": 1.264911e-25,
      "OMEGA": 0.148,
      "PC": 4620.42,
      "RKTZRA": 0.27814012,
      "S025E": 409.2612,
      "SG": 0.522,
      "SRKOMG": 0.13846,
      "SRKPC": 4665,
      "SRKTC": 365.57001,
      "TB": 225.4,
      "TC": 365,
      "TPT": 87.89,
      "VB": 0.069086994,
      "VC": 0.18061513,
      "VLSTD": 0.080856602,
      "ZC": 0.275
    }
  },
  {
    "_id": "c56379c2-3fdd-46c1-a78b-ddf4857a966b",
    "cas": "108-05-4",
    "Name_ZH": "醋酸乙烯",
    "Name_EN": "VINYL-ACETATE",
    "Molecular_formula": "C4H6O2-1",
    "Alias": "C4H6O2-1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/108-05-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/108-05-4.svg",
    "smiles": "CC(=O)OC=C",
    "MW": 86.09044,
    "props": {
      "API": 20.8895,
      "CHARGE": null,
      "DCPLS": null,
      "DGFORM": -227900,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -316103.4,
      "DHSFRM": null,
      "DHVLB": 32012.4,
      "FREEZEPT": 173,
      "HCOM": -1949000,
      "HCTYPE": null,
      "HFUS": 5370,
      "MUP": 5.3758719e-25,
      "OMEGA": 0.34,
      "PC": 4356.975,
      "RKTZRA": 0.26440069,
      "S025E": null,
      "SG": 0.928542,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 346,
      "TC": 525,
      "TPT": 180.35,
      "VB": 0.099590422,
      "VC": 0.26046994,
      "VLSTD": 0.091827364,
      "ZC": 0.26
    }
  },
  {
    "_id": "c57241e4-e4e3-4538-9097-8769b5349887",
    "cas": "629-92-5",
    "Name_ZH": "十九烷",
    "Name_EN": "N-NONADECANE",
    "Molecular_formula": "C19H40",
    "Alias": "C19H40",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-92-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-92-5.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCC",
    "MW": 268.5266,
    "props": {
      "API": 47.8,
      "CHARGE": null,
      "DCPLS": 66.2102,
      "DGFORM": 108982.4,
      "DGSFRM": 49460,
      "DHAQFM": null,
      "DHFORM": -435427.2,
      "DHSFRM": -596210,
      "DHVLB": 56061.252,
      "FREEZEPT": 305,
      "HCOM": -11782300,
      "HCTYPE": null,
      "HFUS": 45810,
      "MUP": 0,
      "OMEGA": 0.827,
      "PC": 1114.575,
      "RKTZRA": 0.22153233,
      "S025E": null,
      "SG": 0.7892,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 603.1,
      "TC": 756,
      "TPT": 305.04,
      "VB": 0.48090146,
      "VC": 1.13,
      "VLSTD": 0.34104845,
      "ZC": 0.228
    }
  },
  {
    "_id": "c6a99ea1-1ffc-4817-ae9a-7598c73f2b52",
    "cas": "10192-32-2",
    "Name_ZH": "二十四烯",
    "Name_EN": "1-TETRACOSENE",
    "Molecular_formula": "C24H48",
    "Alias": "C24H48-D1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/10192-32-2.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/10192-32-2.svg",
    "smiles": "C(CCCCCCCCCCC=C)CCCCCCCCCCC",
    "MW": 336.64512,
    "props": {
      "API": 43.3629,
      "CHARGE": null,
      "DCPLS": 43.5228,
      "DGFORM": 236000,
      "DGSFRM": 228000,
      "DHAQFM": null,
      "DHFORM": -413100,
      "DHSFRM": -571700,
      "DHVLB": 65192.7,
      "FREEZEPT": 318.45,
      "HCOM": -14510000,
      "HCTYPE": null,
      "HFUS": 52500,
      "MUP": 1.65905e-25,
      "OMEGA": 0.9508,
      "PC": 933.275,
      "RKTZRA": 0.23244,
      "S025E": null,
      "SG": 0.809205,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 663.2,
      "TC": 803.32,
      "TPT": 318.45,
      "VB": 0.627047,
      "VC": 1.40796,
      "VLSTD": 0.421403552,
      "ZC": 0.246
    }
  },
  {
    "_id": "c8f8a440-5c05-4339-b678-d247c9894d35",
    "cas": "2437-56-1",
    "Name_ZH": "十三烯",
    "Name_EN": "1-TRIDECENE",
    "Molecular_formula": "C13H26",
    "Alias": "C13H26-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/2437-56-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/2437-56-1.svg",
    "smiles": "CCCCCCCCCCCC=C",
    "MW": 182.34944,
    "props": {
      "API": 52.4,
      "CHARGE": null,
      "DCPLS": 60.6873,
      "DGFORM": 146370.53,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -186103.26,
      "DHSFRM": -9.999,
      "DHVLB": 45008.1,
      "FREEZEPT": 250.1,
      "HCOM": -8007300,
      "HCTYPE": null,
      "HFUS": 22830,
      "MUP": 1.61165e-25,
      "OMEGA": 0.598,
      "PC": 1702.26,
      "RKTZRA": 0.24167948,
      "S025E": null,
      "SG": 0.7692,
      "SRKOMG": 0.611658,
      "SRKPC": 1770.01,
      "SRKTC": 675,
      "TB": 505.9,
      "TC": 674,
      "TPT": 250.08,
      "VB": 0.30613762,
      "VC": 0.65148,
      "VLSTD": 0.2376433,
      "ZC": 0.248
    }
  },
  {
    "_id": "c9224ffc-a1fb-42e5-9337-5e4dfc68c49c",
    "cas": "109-67-1",
    "Name_ZH": "戊烯",
    "Name_EN": "1-PENTENE",
    "Molecular_formula": "C5H10",
    "Alias": "C5H10-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/109-67-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/109-67-1.svg",
    "smiles": "CCCC=C",
    "MW": 70.1344,
    "props": {
      "API": 87.6,
      "CHARGE": 0,
      "DCPLS": 49.4616,
      "DGFORM": 79172.388,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -20934,
      "DHSFRM": -9.999,
      "DHVLB": 25212.91,
      "FREEZEPT": 107.9,
      "HCOM": -3129600,
      "HCTYPE": null,
      "HFUS": 5937.4,
      "MUP": 1.264911e-25,
      "OMEGA": 0.245,
      "PC": 4053,
      "RKTZRA": 0.29101139,
      "S025E": 682.102,
      "SG": 0.6457,
      "SRKOMG": 0.23421,
      "SRKPC": 3528.74,
      "SRKTC": 464.78,
      "TB": 303.1,
      "TC": 464.7,
      "TPT": 108.016,
      "VB": 0.11134774,
      "VC": 0.29550701,
      "VLSTD": 0.10891505,
      "ZC": 0.31
    }
  },
  {
    "_id": "d3e4d5b6-0001-44a2-9d1a-ba567898a5f6",
    "cas": "112-41-4",
    "Name_ZH": "十二烯",
    "Name_EN": "1-DODECENE",
    "Molecular_formula": "C12H24",
    "Alias": "C12H24-2",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-41-4.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/112-41-4.svg",
    "smiles": "CCCCCCCCCCC=C",
    "MW": 168.32256,
    "props": {
      "API": 54.1,
      "CHARGE": null,
      "DCPLS": 338.3522494,
      "DGFORM": 137996.93,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -165462.34,
      "DHSFRM": -9.999,
      "DHVLB": 42998.436,
      "FREEZEPT": 238,
      "HCOM": -7397700,
      "HCTYPE": null,
      "HFUS": 19910,
      "MUP": 1.64009e-25,
      "OMEGA": 0.558,
      "PC": 1854.2475,
      "RKTZRA": 0.24625724,
      "S025E": null,
      "SG": 0.7623,
      "SRKOMG": 0.56356,
      "SRKPC": 1890.01,
      "SRKTC": 657,
      "TB": 486.5,
      "TC": 657,
      "TPT": 237.95,
      "VB": 0.27966513,
      "VC": 0.59548,
      "VLSTD": 0.22129844,
      "ZC": 0.251
    }
  },
  {
    "_id": "d660a10c-c55c-4989-868b-392cedda5651",
    "cas": "646-31-1",
    "Name_ZH": "二十四烷",
    "Name_EN": "N-TETRACOSANE",
    "Molecular_formula": "C24H50",
    "Alias": "C24H50",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/646-31-1.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/646-31-1.svg",
    "smiles": "CCCCCCCCCCCCCCCCCCCCCCCC",
    "MW": 338.661,
    "props": {
      "API": 44.7868,
      "CHARGE": null,
      "DCPLS": 132.097,
      "DGFORM": 148100,
      "DGSFRM": 66520,
      "DHAQFM": null,
      "DHFORM": -540000,
      "DHSFRM": -739310,
      "DHVLB": 61376.5,
      "FREEZEPT": 323.75,
      "HCOM": -14790000,
      "HCTYPE": null,
      "HFUS": 54894,
      "MUP": 0,
      "OMEGA": 1.07102,
      "PC": 980,
      "RKTZRA": 0.22839,
      "S025E": null,
      "SG": 0.80267,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 664.429,
      "TC": 804,
      "TPT": 323.75,
      "VB": 0.631102,
      "VC": 1.41112,
      "VLSTD": 0.422580891,
      "ZC": 0.218
    }
  },
  {
    "_id": "dc295a9b-2c60-4b24-bde7-d67c182e9409",
    "cas": "111-66-0",
    "Name_ZH": "辛烯",
    "Name_EN": "1-OCTENE",
    "Molecular_formula": "C8H16",
    "Alias": "C8H16-16",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/111-66-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/111-66-0.svg",
    "smiles": "CCCCCCC=C",
    "MW": 112.21504,
    "props": {
      "API": 65.2,
      "CHARGE": 0,
      "DCPLS": 62.1886,
      "DGFORM": 104293.19,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -82982.376,
      "DHSFRM": null,
      "DHVLB": 33787.476,
      "FREEZEPT": 171.4,
      "HCOM": -4960550,
      "HCTYPE": null,
      "HFUS": 15310,
      "MUP": 9.4868328e-26,
      "OMEGA": 0.386,
      "PC": 2624.3175,
      "RKTZRA": 0.26061843,
      "S025E": 1091.3632,
      "SG": 0.7193,
      "SRKOMG": 0.37779,
      "SRKPC": 2550,
      "SRKTC": 566.59998,
      "TB": 394.4,
      "TC": 566.6,
      "TPT": 171.45,
      "VB": 0.17968983,
      "VC": 0.46670619,
      "VLSTD": 0.1564058,
      "ZC": 0.26
    }
  },
  {
    "_id": "de0add19-d0d6-47f8-8d7b-3dc0bb041a53",
    "cas": "7732-18-5",
    "Name_ZH": "水",
    "Name_EN": "WATER",
    "Molecular_formula": "H2O",
    "Alias": "H2O",
    "Type": "无机物",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/7732-18-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/7732-18-5.svg",
    "smiles": "O",
    "MW": 18.01528,
    "props": {
      "API": 10,
      "CHARGE": 0,
      "DCPLS": 38.0282,
      "DGFORM": -228766.75,
      "DGSFRM": -236760,
      "DHAQFM": null,
      "DHFORM": -241997.04,
      "DHSFRM": -292920,
      "DHVLB": 40683.136,
      "FREEZEPT": 273.2,
      "HCOM": 0,
      "HCTYPE": null,
      "HFUS": 6001.74,
      "MUP": 5.6920997e-25,
      "OMEGA": 0.344,
      "PC": 22048.32,
      "RKTZRA": 0.2431719,
      "S025E": null,
      "SG": 1,
      "SRKOMG": 0.33509,
      "SRKPC": 22055,
      "SRKTC": 647.13,
      "TB": 373.2,
      "TC": 647.3,
      "TPT": 273.16,
      "VB": 0.01963607,
      "VC": 0.05589534,
      "VLSTD": 0.018049988,
      "ZC": 0.229
    }
  },
  {
    "_id": "dfa5ac1c-895b-4a6a-af8b-f415d5cedd97",
    "cas": "18435-45-5",
    "Name_ZH": "十九烯",
    "Name_EN": "1-NONADECENE",
    "Molecular_formula": "C19H38",
    "Alias": "C19H38-D1",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/18435-45-5.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/18435-45-5.svg",
    "smiles": "C(CCCCCCCCC)CCCCCCCC=C",
    "MW": 266.51072,
    "props": {
      "API": 46.7294,
      "CHARGE": null,
      "DCPLS": 48.768,
      "DGFORM": 194100,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -309600,
      "DHSFRM": null,
      "DHVLB": 55125.5,
      "FREEZEPT": 296.55,
      "HCOM": -11665400,
      "HCTYPE": null,
      "HFUS": 38800,
      "MUP": 1.13763e-25,
      "OMEGA": 0.87373,
      "PC": 1165,
      "RKTZRA": 0.23836,
      "S025E": null,
      "SG": 0.79392,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 601.7,
      "TC": 754.799,
      "TPT": 296.55,
      "VB": 0.476516,
      "VC": 0.9875,
      "VLSTD": 0.337841453,
      "ZC": 0.248
    }
  },
  {
    "_id": "e00b0170-7ed5-4f10-9734-4b4365185a4c",
    "cas": "592-76-7",
    "Name_ZH": "庚烯",
    "Name_EN": "1-HEPTENE",
    "Molecular_formula": "C7H14",
    "Alias": "C7H14-7",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/592-76-7.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/592-76-7.svg",
    "smiles": "C(CCC)CC=C",
    "MW": 98.18816,
    "props": {
      "API": 70.2,
      "CHARGE": 0,
      "DCPLS": 52.5733,
      "DGFORM": 95877.72,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -62341.452,
      "DHSFRM": null,
      "DHVLB": 31107.924,
      "FREEZEPT": 154.3,
      "HCOM": -4348900,
      "HCTYPE": null,
      "HFUS": 12640,
      "MUP": 9.4868328e-26,
      "OMEGA": 0.358,
      "PC": 2837.1,
      "RKTZRA": 0.26127508,
      "S025E": 954.9428,
      "SG": 0.7015,
      "SRKOMG": 0.33512,
      "SRKPC": 2830,
      "SRKTC": 537.28998,
      "TB": 366.8,
      "TC": 537.2,
      "TPT": 154.12,
      "VB": 0.15642095,
      "VC": 0.44078764,
      "VLSTD": 0.14033285,
      "ZC": 0.28
    }
  },
  {
    "_id": "e360fe16-d4ee-40c0-831b-8d2e2e88e1ce",
    "cas": "106-99-0",
    "Name_ZH": "丁二烯",
    "Name_EN": "1,3-BUTADIENE",
    "Molecular_formula": "C4H6-4",
    "Alias": "C4H6-4",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-99-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/106-99-0.svg",
    "smiles": "C=CC=C",
    "MW": 54.09164,
    "props": {
      "API": 94.1,
      "CHARGE": null,
      "DCPLS": 14.2805,
      "DGFORM": 150766.67,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": 110238.44,
      "DHSFRM": null,
      "DHVLB": 22483.116,
      "FREEZEPT": 164.3,
      "HCOM": -2409000,
      "HCTYPE": null,
      "HFUS": 7984,
      "MUP": 0,
      "OMEGA": 0.195,
      "PC": 4326.5775,
      "RKTZRA": 0.2713671,
      "S025E": null,
      "SG": 0.6272,
      "SRKOMG": 0.19251,
      "SRKPC": 4329.91,
      "SRKTC": 425.37,
      "TB": 268.7,
      "TC": 425,
      "TPT": 164.25,
      "VB": 0.08317268,
      "VC": 0.22050489,
      "VLSTD": 0.086475114,
      "ZC": 0.27
    }
  },
  {
    "_id": "e54ad537-d6c1-4046-9c0a-6e18f2c6643f",
    "cas": "75-21-8",
    "Name_ZH": "环氧乙烷",
    "Name_EN": "ETHYLENE-OXIDE",
    "Molecular_formula": "C2H4O",
    "Alias": "C2H4O-2",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/75-21-8.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/75-21-8.svg",
    "smiles": "C1CO1",
    "MW": 44.05316,
    "props": {
      "API": 31.3671,
      "CHARGE": null,
      "DCPLS": 10.7456,
      "DGFORM": -13104.684,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -52669.944,
      "DHSFRM": -9.999,
      "DHVLB": 25623.216,
      "FREEZEPT": 161,
      "HCOM": -1218000,
      "HCTYPE": null,
      "HFUS": 5171.4,
      "MUP": 6.0083274e-25,
      "OMEGA": 0.2,
      "PC": 7194.075,
      "RKTZRA": 0.25905653,
      "S025E": null,
      "SG": 0.868806,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 283.5,
      "TC": 469,
      "TPT": 160.65,
      "VB": 0.049815145,
      "VC": 0.13983877,
      "VLSTD": 0.049943316,
      "ZC": 0.258
    }
  },
  {
    "_id": "e6663dcc-5142-422d-ba2a-aca1cf0d20c3",
    "cas": "111-65-9",
    "Name_ZH": "辛烷",
    "Name_EN": "N-OCTANE",
    "Molecular_formula": "C8H18",
    "Alias": "C8H18-1",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/111-65-9.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/111-65-9.svg",
    "smiles": "CCCCCCCC",
    "MW": 114.23092,
    "props": {
      "API": 68.7,
      "CHARGE": 0,
      "DCPLS": 50.0079,
      "DGFORM": 16412.256,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -208586.38,
      "DHSFRM": -9.999,
      "DHVLB": 34436.43,
      "FREEZEPT": 216.4,
      "HCOM": -5074150,
      "HCTYPE": null,
      "HFUS": 20740,
      "MUP": 0,
      "OMEGA": 0.394,
      "PC": 2482.4625,
      "RKTZRA": 0.25727335,
      "S025E": 1222.0432,
      "SG": 0.7068,
      "SRKOMG": 0.39619,
      "SRKPC": 2486.25,
      "SRKTC": 568.83002,
      "TB": 398.8,
      "TC": 568.8,
      "TPT": 216.38,
      "VB": 0.18738671,
      "VC": 0.49338583,
      "VLSTD": 0.16203751,
      "ZC": 0.259
    }
  },
  {
    "_id": "e792ec44-bb6c-48de-9aa3-5c8e0323ddf9",
    "cas": "18835-32-0",
    "Name_ZH": "二十三烯",
    "Name_EN": "1-TRICOSENE",
    "Molecular_formula": "C23H46",
    "Alias": "C23H46-N3",
    "Type": "烯烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/18835-32-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/18835-32-0.svg",
    "smiles": "C(CCCCCCCCCCC)CCCCCCCCCC=C",
    "MW": 322.61824,
    "props": {
      "API": null,
      "CHARGE": null,
      "DCPLS": null,
      "DGFORM": 228137,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -392100,
      "DHSFRM": null,
      "DHVLB": null,
      "FREEZEPT": null,
      "HCOM": null,
      "HCTYPE": null,
      "HFUS": null,
      "MUP": null,
      "OMEGA": 1.00321,
      "PC": 981.531,
      "RKTZRA": 0.196059987,
      "S025E": null,
      "SG": 0.933025,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 665.002,
      "TC": 810,
      "TPT": null,
      "VB": null,
      "VC": 1.3059,
      "VLSTD": 0.346136,
      "ZC": 0.190325
    }
  },
  {
    "_id": "eb99e428-4460-4425-8d2f-d13285885abe",
    "cas": "629-62-9",
    "Name_ZH": "十五烷",
    "Name_EN": "N-PENTADECANE",
    "Molecular_formula": "C15H32",
    "Alias": "C15H32",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-62-9.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/629-62-9.svg",
    "smiles": "CCCCCCCCCCCCCCC",
    "MW": 212.41908,
    "props": {
      "API": 51.8,
      "CHARGE": null,
      "DCPLS": 12.4101,
      "DGFORM": 75278.664,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -352989.11,
      "DHSFRM": null,
      "DHVLB": 49487.976,
      "FREEZEPT": 283,
      "HCOM": -9343000,
      "HCTYPE": null,
      "HFUS": 34590,
      "MUP": 0,
      "OMEGA": 0.706,
      "PC": 1519.875,
      "RKTZRA": 0.24165575,
      "S025E": null,
      "SG": 0.7721,
      "SRKOMG": 0.704519,
      "SRKPC": 1519.89,
      "SRKTC": 706.8,
      "TB": 543.8,
      "TC": 707,
      "TPT": 283.072,
      "VB": 0.36719198,
      "VC": 0.88950706,
      "VLSTD": 0.27579707,
      "ZC": 0.23
    }
  },
  {
    "_id": "ec03a232-49e2-4dfa-90e3-6e0a9c317351",
    "cas": "50-00-0",
    "Name_ZH": "甲醛",
    "Name_EN": "FORMALDEHYDE",
    "Molecular_formula": "CH2O",
    "Alias": "CH2O",
    "Type": "醛",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/50-00-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/50-00-0.svg",
    "smiles": "C=O",
    "MW": 30.02628,
    "props": {
      "API": 52.8148,
      "CHARGE": 0,
      "DCPLS": 21.0336,
      "DGFORM": -109987.24,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -115974.36,
      "DHSFRM": null,
      "DHVLB": 23027.4,
      "FREEZEPT": 156,
      "HCOM": -526800,
      "HCTYPE": null,
      "HFUS": 5440,
      "MUP": 7.2732385e-25,
      "OMEGA": 0.253,
      "PC": 6586.125,
      "RKTZRA": 0.22313124,
      "S025E": 238.9939,
      "SG": 0.767708,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 254,
      "TC": 408,
      "TPT": 155.15,
      "VB": 0.036919235,
      "VC": 0.10497,
      "VLSTD": 0.039904312,
      "ZC": 0.161
    }
  },
  {
    "_id": "ec3b786f-94d1-4f3f-96f8-096f6716b0cd",
    "cas": "630-08-0",
    "Name_ZH": "一氧化碳",
    "Name_EN": "CARBON-MONOXIDE",
    "Molecular_formula": "CO",
    "Alias": "CO",
    "Type": "无机物",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/630-08-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/630-08-0.svg",
    "smiles": "[C-]#[O+]",
    "MW": 28.0104,
    "props": {
      "API": 340,
      "CHARGE": 0,
      "DCPLS": 618188,
      "DGFORM": -137160,
      "DGSFRM": null,
      "DHAQFM": -28890.79966,
      "DHFORM": -110530,
      "DHSFRM": null,
      "DHVLB": 6045.7392,
      "FREEZEPT": 68.1,
      "HCOM": -283000,
      "HCTYPE": null,
      "HFUS": 840.984,
      "MUP": 3.1622776e-26,
      "OMEGA": 0.049,
      "PC": 3495.7125,
      "RKTZRA": 0.28674427,
      "S025E": 108.3139,
      "SG": 0.3,
      "SRKOMG": 0.060998,
      "SRKPC": 3498.75,
      "SRKTC": 132.92,
      "TB": 81.7,
      "TC": 132.9,
      "TPT": 68.15,
      "VB": 0.035010909,
      "VC": 0.093244089,
      "VLSTD": 0.0535578,
      "ZC": 0.295
    }
  },
  {
    "_id": "f02e6952-8f32-49e2-99b1-7434b9cf980f",
    "cas": "544-76-3",
    "Name_ZH": "十六烷",
    "Name_EN": "N-HEXADECANE",
    "Molecular_formula": "C16H34",
    "Alias": "C16H34",
    "Type": "烷烃",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/544-76-3.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/544-76-3.svg",
    "smiles": "CCCCCCCCCCCCCCCC",
    "MW": 226.44596,
    "props": {
      "API": 50.6,
      "CHARGE": null,
      "DCPLS": 72.8647,
      "DGFORM": 83736,
      "DGSFRM": null,
      "DHAQFM": null,
      "DHFORM": -373588.16,
      "DHSFRM": null,
      "DHVLB": 51246.432,
      "FREEZEPT": 291,
      "HCOM": -9952810,
      "HCTYPE": null,
      "HFUS": 53358,
      "MUP": 0,
      "OMEGA": 0.742,
      "PC": 1418.55,
      "RKTZRA": 0.23896218,
      "S025E": null,
      "SG": 0.7773,
      "SRKOMG": null,
      "SRKPC": null,
      "SRKTC": null,
      "TB": 560,
      "TC": 717,
      "TPT": 291.308,
      "VB": 0.39719702,
      "VC": 0.93997,
      "VLSTD": 0.29199676,
      "ZC": 0.238
    }
  },
  
  {
    "_id": "ff98b65d-e5d3-42ed-9768-1a86b290bb01",
    "cas": "1333-74-0",
    "Name_ZH": "氢气",
    "Name_EN": "HYDROGEN",
    "Molecular_formula": "H2",
    "Alias": "H2",
    "Type": "无机物",
    "sdf": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1333-74-0.sdf",
    "svg": "https://devindata-files.oss-cn-qingdao.aliyuncs.com/properties/1333-74-0.svg",
    "smiles": "[H][H]",
    "MW": 2.01588,
    "props": {
      "API": 340,
      "CHARGE": 0,
      "DCPLS": 6.8922,
      "DGFORM": 0,
      "DGSFRM": null,
      "DHAQFM": -1003.152766,
      "DHFORM": 0,
      "DHSFRM": null,
      "DHVLB": 904.3488,
      "FREEZEPT": 14,
      "HCOM": -241820,
      "HCTYPE": null,
      "HFUS": 117.1,
      "MUP": 0,
      "OMEGA": -0.220142,
      "PC": 1292.98,
      "RKTZRA": 0.32011396,
      "S025E": 130.68,
      "SG": 0.3,
      "SRKOMG": -0.22643,
      "SRKPC": 1313,
      "SRKTC": 33.18,
      "TB": null,
      "TC": 33.18,
      "TPT": 13.95,
      "VB": 0.028612729,
      "VC": 0.0650323,
      "VLSTD": 0.0535578,
      "ZC": 0.304796
    }
  }
];

//物质属性名称列表
export const materialPropsName = [
  {
    "_id": "01ce309a-6694-44b0-a684-78516cb7cc32",
    "code": "Gfg",
    "Unit": "kJ/kmol",
    "Description_EN": "Standard Gibbs free energy of formation for ideal gas at 298.15 K (ΔfG°g).",
    "Description_ZH": "理想气体在 298.15 K 时的标准生成吉布斯自由能 ΔfG°g",
    "alias": "标准气体生成吉布斯自由能",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "12bf204d-7ece-4dca-8406-ca2aa9912a49",
    "code": "rhog_STP",
    "Unit": "mol/m³",
    "Description_EN": "Ideal-gas molar density at STP (ρg, 298 K, 1 atm).",
    "Description_ZH": "标准状态 (298.15 K, 1 atm) 下理想气体的摩尔密度",
    "alias": "标准气体摩尔密度",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "15d6bbd4-3ec2-465e-9cdd-6924d10b1947",
    "code": "rhol_STP",
    "Unit": "mol/m³",
    "Description_EN": "Liquid molar density at STP (ρl, 298 K, 1 atm).",
    "Description_ZH": "标准状态下液体的摩尔密度",
    "alias": "标准液体摩尔密度",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "22d63475-27b7-468d-94aa-94b601ec9162",
    "code": "Hvap_298",
    "Unit": "kJ/kmol",
    "Description_EN": "Enthalpy of vaporization at 298.15 K (ΔHvap, 298 K).",
    "Description_ZH": "298.15 K 下的汽化焓 ΔHvap, 298 K",
    "alias": "标准汽化焓",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "23a1f0e0-97c1-47be-9487-0b66f79fe6cf",
    "code": "HCTYPE",
    "Unit": null,
    "Description_EN": "Hydrocarbon type for Kabadi-Danner mixingrules. Nonhydrocarbons=0, Alkanes=1,Naphthenes=2, Alkenes=3, Dialkenes=4Aromatics=5, Cycoalkenes=6, Acetylenes=7.",
    "Description_ZH": "Kabadi-Danner 混合规则中的烃类型编号：非烃=0，烷烃=1，环烷烃=2，烯烃=3，二烯烃=4，芳香烃=5，环烯烃=6，炔烃=7",
    "alias": "烃类类型",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "406e34b8-e263-4aa6-9fdc-12552dc2710f",
    "code": "Hfg",
    "Unit": "kJ/kmol",
    "Description_EN": "Standard enthalpy of formation for ideal gas at 298.15 K (ΔfH°g).",
    "Description_ZH": "理想气体在 298.15 K 时的标准生成焓 ΔfH°g",
    "alias": "标准气体生成焓",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "44098a4c-3b8b-4afb-bf1f-4ab8d2e15ab8",
    "code": "DGFORM",
    "Unit": "kJ/kmol",
    "Description_EN": "Standard free energy of formation for ideal gasat 25 deg C.",
    "Description_ZH": "理想气体在 25°C 时的标准生成自由能",
    "alias": "气体标准生成自由能",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "457e4924-5ab4-40b1-882d-6c8c4e706326",
    "code": "Hf_STP",
    "Unit": "kJ/kmol",
    "Description_EN": "Standard enthalpy of formation of the reference phase at STP (often liquid or solid, ΔfH°STP).",
    "Description_ZH": "标准状态下参考物相 (通常为液相或固相) 的标准生成焓 ΔfH°STP",
    "alias": "标准生成焓",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "4702d355-06c2-4c52-b208-723233950331",
    "code": "OMEGA",
    "Unit": null,
    "Description_EN": "Pitzer acentric factor.",
    "Description_ZH": "Pitzer 不对称因子",
    "alias": "偏心因子",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "4d1f7825-73b1-4fa5-a33c-81468fb5611d",
    "code": "HFUS",
    "Unit": "kJ/kmol",
    "Description_EN": "Heat of fusion.",
    "Description_ZH": "熔化焓",
    "alias": "熔化焓",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "528e394b-3744-4ce3-b56f-e44c8dcb7311",
    "code": "Hfus_Tm",
    "Unit": "kJ/kmol",
    "Description_EN": "Enthalpy of fusion at the melting temperature (ΔHfus, Tm).",
    "Description_ZH": "在熔点 Tm 时的熔化焓 ΔHfus, Tm",
    "alias": "熔点熔化焓",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "574d2feb-5782-4c13-8a92-5395572f13bd",
    "code": "SRKOMG",
    "Unit": null,
    "Description_EN": "Acentric factor for the SRK model",
    "Description_ZH": "SRK 模型的不对称因子",
    "alias": "SRK偏心因子",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "5d773603-62df-4b76-85f7-bc3d8c9d445c",
    "code": "SRKTC",
    "Unit": "K",
    "Description_EN": "Critical temperature for the SRK model",
    "Description_ZH": "SRK 模型的临界温度",
    "alias": "SRK临界温度",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "68a8b541-f811-4153-b834-353727e82315",
    "code": "TB",
    "Unit": "K",
    "Description_EN": "Normal boiling point.",
    "Description_ZH": "正常沸点（常压下沸点）",
    "alias": "常压沸点",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "734edb23-fd8e-4daf-beee-6fb120176fe2",
    "code": "SG",
    "Unit": null,
    "Description_EN": "Standard specific gravity at 60 deg F.",
    "Description_ZH": "在 60°F 时的标准比重",
    "alias": "60F标准比重",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "7385e9f8-6ab0-40d4-a5a9-b54770b8abd0",
    "code": "PC",
    "Unit": "kPa",
    "Description_EN": "Critical pressure.",
    "Description_ZH": "临界压力",
    "alias": "临界压力",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "83b36732-aa57-450d-b8f6-779b589b9027",
    "code": "Tt",
    "Unit": "K",
    "Description_EN": "Triple-point temperature Ttp.",
    "Description_ZH": "三相点温度 Ttp",
    "alias": "三相点温度",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "8786a46a-52f6-49c8-9587-97d10a9d24a2",
    "code": "HCOM",
    "Unit": "kJ/kmol",
    "Description_EN": "Standard enthalpy of combustion at 298.2 K.",
    "Description_ZH": "在 298.2 K 时的标准燃烧焓",
    "alias": "标准燃烧焓",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "87e0a6ee-b0e8-4113-8fd2-e9e2eba80a5d",
    "code": "CHARGE",
    "Unit": null,
    "Description_EN": "lonic charge number (positive for cations,negative for anions).",
    "Description_ZH": "离子电荷数（阳离子为正值，阴离子为负值）",
    "alias": "电荷数",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "8a592d01-bfb2-447a-b69c-e2a24992877f",
    "code": "DHVLB",
    "Unit": "kJ/kmol",
    "Description_EN": "Enthalpy of vaporization at TB.",
    "Description_ZH": "在正常沸点 TB 下的汽化焓",
    "alias": "沸点汽化焓",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "925a3636-89e6-466d-8235-fec3310affb4",
    "code": "S0gs",
    "Unit": "kJ/kmol-K",
    "Description_EN": "Standard molar entropy of the ideal gas at 298.15 K (S°298 K).",
    "Description_ZH": "理想气体在 298.15 K 时的标准摩尔熵 S°298 K",
    "alias": "标准气体摩尔熵",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "925e8e9e-1225-46ea-8a26-7b07f1428b7a",
    "code": "Hsub_Tt",
    "Unit": "kJ/kmol",
    "Description_EN": "Enthalpy of sublimation at the triple point (ΔHsub, Ttp).",
    "Description_ZH": "三相点 Ttp 下的升华焓 ΔHsub, Ttp",
    "alias": "三相点升华焓",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "96f412cc-ea55-475c-85d6-6e0a455a0a87",
    "code": "SRKPC",
    "Unit": "kPa",
    "Description_EN": "Critical pressure for the SRK model",
    "Description_ZH": "SRK 模型的临界压力",
    "alias": "SRK临界压力",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "a1227747-cca7-4c50-a659-aad97934b913",
    "code": "DGSFRM",
    "Unit": "kJ/kmol",
    "Description_EN": "Solid free energy of formation at 25 deg C.",
    "Description_ZH": "25°C 时固体的标准生成自由能",
    "alias": "固体标准生成自由能",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "a9ec1e24-716b-4941-9fe2-ceaf276fc0d3",
    "code": "rhol_60F",
    "Unit": "mol/m³",
    "Description_EN": "Liquid molar density at 60 °F (15.556 °C) and 1 atm; petroleum standard reference.",
    "Description_ZH": "60 °F (15.556 °C)、1 atm 条件下的液体摩尔密度 (石油计量标准)",
    "alias": "60F液体摩尔密度",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "ac2d389f-6106-4fed-9329-25f7224730b6",
    "code": "omega",
    "Unit": null,
    "Description_EN": "Pitzer acentric factor ω.",
    "Description_ZH": "Pitzer 偏心因子 ω",
    "alias": "偏心因子",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "af0e5f8f-53b9-4bd9-b39c-02b67dc11d98",
    "code": "Vmg_STP",
    "Unit": "m³/mol",
    "Description_EN": "Ideal-gas molar volume at STP (298.15 K, 1 atm).",
    "Description_ZH": "标准状态下 (298.15 K, 1 atm) 理想气体的摩尔体积",
    "alias": "标准气体摩尔体积",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "b2d32199-2e1e-4e97-b1ab-623b1d2759be",
    "code": "rhoc",
    "Unit": "mol/m³",
    "Description_EN": "Critical molar density ρc at (Tc, Pc).",
    "Description_ZH": "在临界点 (Tc, Pc) 的临界摩尔密度 ρc",
    "alias": "临界密度",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "b845e309-556a-40e6-b0ad-a0bd9e6cc1b1",
    "code": "API",
    "Unit": null,
    "Description_EN": "Standard APl gravity",
    "Description_ZH": "标准 API 重力度",
    "alias": "API度",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "c75a7924-351d-4ddb-89d8-fa010abd0077",
    "code": "MW",
    "Unit": null,
    "Description_EN": "Molecular weight.",
    "Description_ZH": "分子量",
    "alias": "分子量",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "cd698ba9-b461-4ff3-acf8-47d48647be66",
    "code": "Vml_STP",
    "Unit": "m³/mol",
    "Description_EN": "Liquid molar volume at STP (298.15 K, 1 atm).",
    "Description_ZH": "标准状态下液体的摩尔体积",
    "alias": "标准液体摩尔体积",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "cea27515-b43a-4e8f-b58f-ac5348b420e6",
    "code": "DHAQFM",
    "Unit": "cal/mol",
    "Description_EN": "Aqueous phase heat of formation at infinitedilution and 25 deg C on the molality scalebase, standard = 1 mol/kg. For ionic speciesand molecular solutes in electrolyte systems.",
    "Description_ZH": "水相在 25°C、无限稀释条件下（以质量摩尔度 molality 为基准，标准=1 mol/kg）的生成热，适用于电解质体系中的离子及分子溶质",
    "alias": "液相标准生成焓",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "d26086dc-ad04-4daf-b6c7-c8d15c178c95",
    "code": "TC",
    "Unit": "K",
    "Description_EN": "Critical temperature.",
    "Description_ZH": "临界温度",
    "alias": "临界温度",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "da34a0a4-5dbb-423d-94b1-6aa8f7c84553",
    "code": "Pt",
    "Unit": "kPa",
    "Description_EN": "Triple-point pressure Ptp.",
    "Description_ZH": "三相点压力 Ptp",
    "alias": "三相点压力",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "db415fc5-d027-4cec-af6f-1fbf792985f0",
    "code": "Hvap_Tb",
    "Unit": "kJ/kmol",
    "Description_EN": "Enthalpy of vaporization at the normal boiling point (ΔHvap, Tb).",
    "Description_ZH": "正常沸点 Tb 下的汽化焓 ΔHvap, Tb",
    "alias": "沸点汽化焓",
    "Common_Name": [],
    "source": "CHEMIACL"
  },
  {
    "_id": "dbdcd17e-e2dd-4ad5-a4e7-9c8dee4a2f3c",
    "code": "DHSFRM",
    "Unit": "kJ/kmol",
    "Description_EN": "Solid enthalpy of formation at 25 deg C.",
    "Description_ZH": "25°C 时固体的标准生成焓",
    "alias": "固相标准生成焓",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "e5de9073-0526-4fa8-89b7-03f23d1b7767",
    "code": "S025E",
    "Unit": "kJ/kmol-K",
    "Description_EN": "Sum of element entropies at 25 C.",
    "Description_ZH": "在 25°C 时各元素熵之和",
    "alias": "元素熵和",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "e83c7d28-fa95-4aeb-847a-64d0338de970",
    "code": "DCPLS",
    "Unit": "kJ/kmol-K",
    "Description_EN": "Difference between liquid and solid Cp at triplepoint.",
    "Description_ZH": "在三相点处，液体和固体的定压比热（Cp）差值",
    "alias": "液固定压比热差",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "ec135ade-a27e-4159-93be-9f2bada02b03",
    "code": "RKTZRA",
    "Unit": null,
    "Description_EN": "Parameter for the Rackett liquid molar volumemodel.",
    "Description_ZH": "Rackett 液体摩尔体积模型参数",
    "alias": "Rackett参数",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "ecb4e9c3-fd4d-42e5-84b5-dbfa412ab86f",
    "code": "FREEZEPT",
    "Unit": "K",
    "Description_EN": "Freeze point.",
    "Description_ZH": "冻点",
    "alias": "凝固点",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "ef0d0f35-c883-4bb3-adf7-3cb3a2f2e796",
    "code": "TPT",
    "Unit": "K",
    "Description_EN": "Triple point temperature.",
    "Description_ZH": "三相点温度",
    "alias": "三相点温度",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "f2850cd7-7a4e-4133-a51b-4a817d94120d",
    "code": "DHFORM",
    "Unit": "kJ/kmol",
    "Description_EN": "Standard enthalpy of formation for ideal gas at25 deg C.",
    "Description_ZH": "理想气体在 25°C 时的标准生成焓",
    "alias": "气相标准生成焓",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "3bf56b64-9c1c-4f67-9c94-1a830d10560d",
    "code": "VLSTD",
    "Unit": "m³/kmol",
    "Description_EN": "Standard liquid molar volume at 60 deg f.",
    "Description_ZH": "在 60°F 时的标准液体摩尔体积",
    "alias": "60F液相摩尔体积",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "cb861743-eaa8-4b22-9a24-6aedc4d99a1f",
    "code": "VC",
    "Unit": "m³/kmol",
    "Description_EN": "Critical volume.",
    "Description_ZH": "临界体积",
    "alias": "临界体积",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "f4033f1e-faa6-498a-8746-b78fd900aeb9",
    "code": "ZC",
    "Unit": null,
    "Description_EN": "Critical compressibility factor.",
    "Description_ZH": "临界压缩因子",
    "alias": "临界压缩因子",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "12bb0fa5-fcf3-43d6-b5fb-2eca3228b26e",
    "code": "MUP",
    "Unit": "(J*m³)**.5",
    "Description_EN": "Dipole moment.",
    "Description_ZH": "偶极矩",
    "alias": "偶极矩",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "f286fd2e-5268-473a-872c-0da39f977860",
    "code": "VB",
    "Unit": "m³/kmol",
    "Description_EN": "Liquid molar volume at TB.",
    "Description_ZH": "正常沸点 TB 下的液体摩尔体积",
    "alias": "沸点液相摩尔体积",
    "Common_Name": [],
    "source": "ASPEN"
  },
  {
    "_id": "eb8b82b0-4bb8-4fc0-9ec7-1eb958253478",
    "code": "PHASE_STP",
    "Unit": null,
    "Description_EN": "Phase designation at standard temperature and pressure (298.15 K, 1 atm); g = gas, l = liquid, s = solid.",
    "Description_ZH": "标准状态 (298.15 K, 1 atm) 下的物相标识；g = 气相，l = 液相，s = 固相",
    "alias": "标准相态",
    "Common_Name": [],
    "source": "CHEMIACL"
  }
]